<template>
    <div class="main-content">
        <!-- TOASTS DE NOTIFICAÇÃO -->
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 flex-nowrap text-nowrap align-items-center"
                    style="overflow-x: auto; scrollbar-width: none;">
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/">Início</router-link>
                    </li>
                    <li class="breadcrumb-item active text-dark small" aria-current="page">
                        <router-link class="nav-link d-inline" to="/list-page-lead">Páginas de Captura</router-link>
                    </li>
                    <li class="breadcrumb-item active text-dark small" aria-current="page">
                        Respostas (leads)
                    </li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <!-- Cabeçalho Principal -->
            <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 border-bottom pb-3">
                <div class="flex-shrink-0">
                    <h4 class="mb-0 fw-bold">
                        Leads da Página 
                        <span v-if="pageInfo" class="text-primary fs-5 ms-1" :title="pageInfo.title">
                            {{ pageInfo.title.length > 20 ? pageInfo.title.substring(0, 20) + '...' : pageInfo.title }}
                        </span>
                    </h4>
                    <span class="text-muted fs-7">Exibindo {{ leads.length }} de {{ totalItems }} respostas</span>
                </div>

                <div
                    class="d-flex flex-nowrap gap-2 align-items-center w-100 w-md-auto justify-content-start justify-content-md-end">

                    <!-- Ações em Massa (Apenas na Lista) -->
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0 && currentView === 'list'" class="flex-shrink-0">
                            <button class="btn btn-pmg-danger btn-sm px-3" @click="confirmDelete(null, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <!-- Dropdown Unificado: Relatórios & Ferramentas -->
<div class="dropdown flex-shrink-0 ms-2">
    <button class="btn btn-pmg-light dropdown-toggle d-flex align-items-center gap-2 shadow-sm fw-medium" 
            type="button" 
            data-bs-toggle="dropdown" 
            aria-expanded="false">
        <i class="bi bi-tools text-secondary"></i> Relatórios / Ferramentas
    </button>
    
    <ul class="dropdown-menu dropdown-menu-end shadow border-0 rounded-3 p-2" style="min-width: 230px;">
       

        <!-- Categoria 1: Ações do Sistema -->
        <li>
            <button class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" @click="refreshData" :disabled="loading">
                <i class="bi bi-arrow-clockwise text-secondary" :class="{ 'spin-animation': loading }"></i> 
                <span>Atualizar Dados da Tela</span>
            </button>
        </li>
         <li><hr class="dropdown-divider my-2"></li>
        <!-- Categoria 2: Métricas & Visualizações -->
        <li><h6 class="dropdown-header text-uppercase fs-8 fw-bold opacity-75">Análises & Agenda</h6></li>
        <li>
            <button class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" @click="openCalendarModal">
                <i class="bi bi-calendar-event-fill text-success"></i> 
                <span>Calendário de Retornos</span>
            </button>
        </li>
        <li>
            <button class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" @click="openFunnelModal">
                <i class="bi bi-funnel-fill text-primary"></i> 
                <span>Funil de Conversão</span>
            </button>
        </li>
        <li>
            <button class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" @click="openHeatmapModal">
                <i class="bi bi-geo-alt-fill text-danger"></i> 
                <span>Mapa de Calor</span>
            </button>
        </li>

        <li><hr class="dropdown-divider my-2"></li>

        <!-- Categoria 3: Exportações -->
        <li><h6 class="dropdown-header text-uppercase fs-8 fw-bold opacity-75">Exportação de Dados</h6></li>
        <li>
            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" href="#" @click.prevent="openReportModal('pdf')">
                <i class="bi bi-file-earmark-pdf-fill text-danger"></i> 
                <span>Relatório Geral (PDF)</span>
            </a>
        </li>
        <li>
            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2" href="#" @click.prevent="openReportModal('xlsx')">
                <i class="bi bi-file-earmark-excel-fill text-success"></i> 
                <span>Planilha Completa (Excel)</span>
            </a>
        </li>

        
    </ul>
</div>

                    <!-- Botão Agenda de Tarefas -->
                    <button class="btn btn-pmg-light text-warning border-warning-subtle position-relative flex-shrink-0"
                        @click="openFollowUpsModal" title="Agenda de Retornos e Tarefas">
                        <i class="bi bi-alarm-fill"></i> Tarefas
                        <span v-if="todayFollowUps.length > 0"
                            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger shadow-sm"
                            style="font-size: 0.6rem; z-index: 10;">
                            {{ todayFollowUps.length }}
                        </span>
                    </button>

                    <!-- Botão Filtro -->
                    <button class="btn btn-pmg-light flex-shrink-0" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <!-- Alternador de Visualização (Lista / Kanban) -->
                    <div class="btn-group flex-shrink-0 border-start" style="margin-left: 8px; padding-left: 8px;"
                        role="group">
                        <button type="button" class="btn"
                            :class="currentView === 'list' ? 'btn-pmg-dark text-white' : 'btn-pmg-light'"
                            @click="currentView = 'list'">
                            <i class="bi bi-list-ul me-1"></i> Lista
                        </button>
                        <button type="button" class="btn"
                            :class="currentView === 'kanban' ? 'btn-pmg-dark text-white' : 'btn-pmg-light'"
                            @click="currentView = 'kanban'">
                            <i class="bi bi-kanban me-1"></i> Kanban
                        </button>
                    </div>
                </div>
            </div>


            <!-- Área do Filtro -->
            <!-- Área do Filtro -->
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-4 p-4 shadow-sm">

                    <!-- LINHA 1: FILTROS DO LEAD -->
                    <h6 class="fw-bold text-dark mb-3 small text-uppercase"><i
                            class="bi bi-person-lines-fill text-primary me-2"></i> Filtros Principais do Lead</h6>
                    <div class="row g-3 align-items-end mb-4">
                        <div class="col-md-3">
                            <label class="form-label fw-bold text-secondary small mb-1">Buscar (Nome, Respostas,
                                etc)</label>
                            <div class="input-group">
                                <span class="input-group-text bg-light border-end-0"><i
                                        class="bi bi-search text-muted"></i></span>
                                <input v-model="filter.search" type="text"
                                    class="form-control form-control-pmg bg-white border-start-0 ps-0"
                                    placeholder="Digite um termo...">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-bold text-secondary small mb-1">Status do Lead</label>
                            <select v-model="filter.status" class="form-select form-control-pmg bg-white">
                                <option value="">Todos os Status</option>
                                <option v-for="col in kanbanColumns" :key="col.id" :value="col.id">{{ col.title }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-bold text-secondary small mb-1">Data Contato (De)</label>
                            <input v-model="filter.contacted_start_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-bold text-secondary small mb-1">Data Contato (Até)</label>
                            <input v-model="filter.contacted_end_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>

                        <!-- FILTRO UNIFICADO DE RETORNO -->
                        <div class="col-md-6">
                            <label class="form-label fw-bold text-secondary small mb-1">
                                <i class="bi bi-alarm text-warning me-1"></i> Data de Retorno Agendado (De)
                            </label>
                            <input v-model="filter.return_start_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-bold text-secondary small mb-1">
                                <i class="bi bi-alarm text-warning me-1"></i> Data de Retorno Agendado (Até)
                            </label>
                            <input v-model="filter.return_end_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>
                    </div>

                    <!-- LINHA 2: FILTROS DE PRODUTOS/SERVIÇOS COM DROPDOWN PADRONIZADO -->
                    <div
                        class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 border-top pt-4 gap-2">
                        <h6 class="fw-bold text-dark m-0 small text-uppercase">
                            <i class="bi bi-box-seam-fill text-primary me-2"></i> Vínculos (Produtos e Serviços)
                        </h6>

                        <!-- Dropdown Estilizado (Igual ao Relatórios / Ferramentas) -->
                        <div class="dropdown">
                            <button
                                class="btn btn-pmg-light dropdown-toggle px-3 py-1 shadow-sm rounded-3 fw-bold text-secondary bg-light"
                                type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                style="font-size: 0.8rem; height: auto;">
                                <i class="bi bi-calendar-range text-primary me-1"></i>
                                Precisão: <span class="text-dark ms-1">
                                    {{
                                        reportFilters.date_precision === 'full' ? 'Data Completa (Dia/Mês/Ano)' :
                                            (reportFilters.date_precision === 'month_year' ? 'Apenas Mês/Ano' :
                                                (reportFilters.date_precision === 'month' ? 'Apenas o Mês' : 'Apenas o Dia'))
                                    }}
                                </span>
                            </button>

                            <ul class="dropdown-menu shadow border-0 py-2 rounded-3"
                                style="font-size: 0.85rem; z-index: 1070;">
                                <li>
                                    <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Filtrar por</h6>
                                </li>
                                <li>
                                    <a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                        @click.prevent="reportFilters.date_precision = 'full'"
                                        :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'full' }">
                                        <i class="bi bi-calendar-check text-success fs-6"></i> Data Completa
                                        (Dia/Mês/Ano)
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                        @click.prevent="reportFilters.date_precision = 'month_year'"
                                        :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'month_year' }">
                                        <i class="bi bi-calendar-month text-warning fs-6"></i> Apenas Mês/Ano
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                        @click.prevent="reportFilters.date_precision = 'month'"
                                        :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'month' }">
                                        <i class="bi bi-calendar2-week text-primary fs-6"></i> Apenas o Mês
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                        @click.prevent="reportFilters.date_precision = 'day'"
                                        :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'day' }">
                                        <i class="bi bi-calendar-day text-info fs-6"></i> Apenas o Dia
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>


                    <div class="row g-3 align-items-end mb-2">
                        <div class="col-md-2">
                            <label class="form-label fw-bold text-secondary small mb-1">Tipo de Item</label>
                            <select v-model="filterProductType" @change="onFilterProductTypeChange"
                                class="form-select form-control-pmg bg-white">
                                <option value="App\Models\Product">Produto</option>
                                <option value="App\Models\Service">Serviço</option>
                            </select>
                        </div>

                        <div class="col-md-3 position-relative">
                            <label class="form-label fw-bold text-secondary small mb-1">Buscar Produto/Serviço</label>
                            <div class="input-group">
                                <input type="text" v-model="filterProductQuery" @input="onFilterProductInput"
                                    @focus="showFilterProductDrop = true" @blur="hideFilterProductDrop"
                                    class="form-control form-control-pmg bg-white"
                                    :placeholder="filterProductType === 'App\\Models\\Product' ? 'Digite para buscar produto...' : 'Digite para buscar serviço...'"
                                    :disabled="!!selectedFilterProduct">

                                <button v-if="selectedFilterProduct"
                                    class="btn btn-light border bg-white text-danger px-3" type="button"
                                    @click="clearFilterProduct" title="Remover item do filtro">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            </div>

                            <div v-if="showFilterProductDrop && filterProductResults.length > 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                style="z-index: 1060; max-height: 250px; overflow-y: auto;">
                                <ul class="list-unstyled mb-0">
                                    <li v-for="it in filterProductResults" :key="it.id"
                                        @mousedown="selectFilterProduct(it)"
                                        class="p-3 autocomplete-item border-bottom cursor-pointer d-flex justify-content-between align-items-center">
                                        <div class="fw-bold text-dark">{{ it.name ?? it.description }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label fw-bold text-secondary small mb-1">Status da Venda</label>
                            <select v-model="filter.item_status" class="form-select form-control-pmg bg-white">
                                <option value="">Todos</option>
                                <option value="nao_negociado">Não Negociado</option>
                                <option value="em_negociacao">Em Negociação</option>
                                <option value="fechado">Fechado</option>
                                <option value="desistencia">Desistência</option>
                            </select>
                        </div>

                        <div class="col-md-2">
                            <label class="form-label fw-bold text-secondary small mb-1">Vigência (De)</label>
                            <input v-model="filter.item_start_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>

                        <div class="col-md-2">
                            <label class="form-label fw-bold text-secondary small mb-1">Vigência (Até)</label>
                            <input v-model="filter.item_end_date" type="date"
                                class="form-control form-control-pmg bg-white">
                        </div>
                    </div>

                    <!-- BOTÕES DE AÇÃO -->
                    <div class="d-flex justify-content-end gap-2 border-top pt-4 mt-3">
                        <button class="btn btn-pmg-light fw-bold px-4" @click="clearAllFilters">
                            <i class="bi bi-eraser me-1"></i> Limpar Filtros
                        </button>
                        <button class="btn btn-dark btn-pmg-dark fw-bold px-5" @click="applyFilter">
                            <i class="bi bi-search me-1"></i> Aplicar Filtros
                        </button>
                    </div>

                </div>
            </div>

            <!-- ================= VISUALIZAÇÃO: LISTA ================= -->
            <div v-if="currentView === 'list'" class="table-responsive" style="min-height: 350px;">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%" class="text-center">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th>Lead / Identificador</th>
                            <th>Status</th>
                            <th class="text-center">Data da Resposta</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="leads.length > 0">
                        <tr v-for="item in leads" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td class="text-center">
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>

                            <td>
                                <span class="fw-bold text-dark text-truncate d-inline-block" style="max-width: 250px;"
                                    :title="getLeadIdentifier(item)">
                                    <i class="bi bi-person-fill text-primary me-1"></i> {{ getLeadIdentifier(item) }}
                                </span>
                            </td>
                            <td style="min-width: 160px;">
                                <div class="dropdown">
                                    <button
                                        class="btn btn-sm dropdown-toggle fw-bold border-0 shadow-sm w-100 d-flex justify-content-between align-items-center px-3 py-2 rounded-3"
                                        type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                        :class="getStatusBadgeClass(item.status)">
                                        <span>{{ getStatusName(item.status) }}</span>
                                    </button>

                                    <ul class="dropdown-menu shadow border-0 py-2 w-100 rounded-3 mt-1"
                                        style="font-size: 0.85rem;">
                                        <li v-for="col in kanbanColumns" :key="col.id">
                                            <a class="dropdown-item fw-medium py-2 d-flex align-items-center gap-2"
                                                href="#" @click.prevent="changeStatusFromList(item, col.id)"
                                                :class="{ 'bg-light': item.status === col.id }">
                                                <span class="d-inline-block rounded-circle shadow-sm"
                                                    style="width: 10px; height: 10px;"
                                                    :class="getDotColor(col.id)"></span>
                                                {{ col.title }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td class="text-muted text-center small position-relative">
                                <!-- Indicador SLA na Lista -->
                                <span v-if="getSlaStatus(item)?.alert"
                                    class="position-absolute top-50 start-0 translate-middle-y ms-2 text-danger"
                                    :title="getSlaStatus(item).text">
                                    <i class="bi fs-5" :class="getSlaStatus(item).icon"></i>
                                </span>
                                {{ formatDate(item.created_at) }}
                            </td>

                            <td class="text-end text-nowrap">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-boundary="window" data-bs-reference="parent">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li>
                                            <a class="dropdown-item fw-medium d-flex align-items-center" href="#"
                                                @click.prevent="openLeadCrmModal(item)">
                                                <i class="bi bi-pencil me-2 text-secondary fs-6"></i>Editar CRM
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item fw-medium d-flex align-items-center" href="#"
                                                @click.prevent="openLeadDetails(item)">
                                                <i class="bi bi-eye me-2 text-secondary fs-6"></i>Ver Respostas
                                            </a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item fw-medium d-flex align-items-center" href="#"
                                                @click.prevent="openAuditModal(item)">
                                                <i class="bi bi-clock-history me-2 text-secondary fs-6"></i>Ver
                                                Histórico
                                            </a>
                                        </li>
                                        <!-- Ação WhatsApp Dinâmica -->
                                        <li v-if="getLeadPhone(item)">
                                            <a class="dropdown-item fw-bold d-flex align-items-center text-success"
                                                href="#" @click.prevent="openWhatsApp(item)">
                                                <i class="bi bi-whatsapp me-2 fs-6"></i>Chamar no WhatsApp
                                            </a>

                                        </li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li>
                                            <a class="dropdown-item text-danger d-flex align-items-center" href="#"
                                                @click.prevent="confirmDelete(item)">
                                                <i class="bi bi-trash3 me-2 fs-6"></i>Excluir
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-inbox fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Nenhuma captação registrada no momento.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="text-center mt-4" v-if="hasMore">
                    <button
                        class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                        @click="loadMore" :disabled="loading" style="min-width: 220px;">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                            aria-hidden="true"></span>
                        <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                    </button>
                </div>
            </div>

            <!-- ================= VISUALIZAÇÃO: KANBAN ================= -->
            <div v-else class="kanban-board-container py-2">
                <div class="d-flex gap-3 overflow-auto pb-3 kanban-scroll-area" style="align-items: flex-start;">

                    <!-- Colunas do Kanban -->
                    <div class="col-kanban flex-shrink-0" v-for="column in kanbanColumns" :key="column.id"
                        @drop="onDrop($event, column.id)" @dragover.prevent @dragenter.prevent>

                        <!-- Altura travada na tela (100vh) para gerar o scroll interno -->
                        <div class="card border-0 rounded-4 shadow-sm p-3 bg-light d-flex flex-column"
                            style="height: calc(100vh - 280px); min-height: 500px;">

                            <div class="d-flex justify-content-between align-items-center mb-3 px-1 flex-shrink-0">
                                <h6 class="fw-bold text-secondary text-uppercase small m-0">{{ column.title }}</h6>
                                <span class="badge bg-white text-dark shadow-sm rounded-pill px-2 py-1">
                                    {{ groupedLeads[column.id]?.length || 0 }}
                                </span>
                            </div>

                            <!-- Contêiner rolável dos cards -->
                            <div class="kanban-cards-container d-flex flex-column gap-3 overflow-y-auto pe-2"
                                style="flex-grow: 1;">
                                <div v-for="lead in groupedLeads[column.id]" :key="lead.id"
                                    class="card border-0 shadow-sm rounded-3 p-3 position-relative kanban-card cursor-grab bg-white mt-3"
                                    :class="[getSlaStatus(lead)?.class || ('border-start border-4 ' + column.cardClass)]"
                                    draggable="true" @dragstart="startDrag($event, lead)">
                                    <div v-if="getSlaStatus(lead)?.alert"
                                        class="position-absolute top-0 start-50 translate-middle badge rounded-pill shadow-sm border"
                                        :class="getSlaStatus(lead).badgeClass" style="z-index: 2;">
                                        <i class="bi me-1" :class="getSlaStatus(lead).icon"></i> {{
                                            getSlaStatus(lead).text }}
                                    </div>
                                    <!-- Cabeçalho do Card (Relógio + Lápis + Excluir) -->
                                    <div class="d-flex justify-content-end align-items-start mb-2">
                                        <div>
                                            <button v-if="getLeadPhone(lead)" class="btn btn-sm text-success p-0 me-2"
                                                @click="openWhatsApp(lead)" title="Chamar no WhatsApp">
                                                <i class="bi bi-whatsapp fs-5"></i>
                                            </button>
                                            <button class="btn btn-sm text-danger p-0" @click="confirmDelete(lead)"
                                                title="Excluir Lead">
                                                <i class="bi bi-trash3 fs-6"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Corpo do Card -->
                                    <div class="text-muted small mb-3">
                                        <div class="fw-bold text-dark fs-6 mb-2 text-truncate"
                                            :title="getLeadIdentifier(lead)">
                                            <i class="bi bi-person-fill text-primary me-1"></i> {{
                                                getLeadIdentifier(lead) }}
                                        </div>
                                        <div v-if="lead.user" class="mb-1 text-truncate text-dark fw-medium"
                                            title="Atendente Responsável">
                                            <i class="bi bi-person-circle text-primary me-1"></i> {{ lead.user.name }}
                                        </div>
                                        <div v-if="lead.contacted_at" class="mb-1 text-dark"
                                            title="Data do Último Contato">
                                            <i class="bi bi-calendar-check me-1 opacity-75"></i> Contato: <strong>{{
                                                formatDate(lead.contacted_at) }}</strong>
                                        </div>

                                        <div class="mb-1 text-dark">
                                            <i class="bi bi-calendar3 me-1 opacity-75"></i>Criação lead: <strong>{{
                                                formatDate(lead.created_at) }}</strong>
                                        </div>
                                        <div class="mb-1 text-truncate" title="Dispositivo">
                                            <i class="bi bi-phone me-1 opacity-75"></i>Dispositivo: <strong>{{
                                                lead.device_type || 'desktop' }}</strong>
                                        </div>
                                        <div class="mb-1 text-truncate" title="Origem (UTM)">
                                            <i class="bi bi-bullseye text-primary me-1"></i> Origem: <strong>{{
                                                lead.utm_source || 'direct' }}</strong>
                                        </div>
                                    </div>

                                    <!-- Grupo de Botões (Rodapé do Card) -->
                                    <div class="d-grid gap-2 mt-auto pt-3">
                                        <!-- Botão Principal: Atendimentos (CRM) -->
                                        <button
                                            class="btn btn-pmg-primary border-0 fw-bold shadow-sm d-flex justify-content-center align-items-center"
                                            @click="openLeadCrmModal(lead)">
                                            <i class="bi bi-headset fs-5 me-2"></i> Atendimentos
                                        </button>

                                        <!-- Botão Secundário: Ver Respostas -->
                                        <button
                                            class="btn btn-light border fw-medium text-secondary d-flex justify-content-center align-items-center"
                                            @click="openLeadDetails(lead)" style="font-size: 0.85rem;">
                                            <i class="bi bi-card-text me-2"></i> Respostas
                                        </button>
                                    </div>

                                </div>
                                <div v-if="!groupedLeads[column.id] || groupedLeads[column.id].length === 0"
                                    class="flex-grow-1 d-flex align-items-center justify-content-center text-muted opacity-50 small border border-dashed rounded-3 p-4">
                                    Arraste cards para cá
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Botão Carregar Mais exclusivo do Kanban -->
                <div class="text-center mt-3 mb-2" v-if="hasMore">
                    <button
                        class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                        @click="loadMore" :disabled="loading" style="min-width: 220px;">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                            aria-hidden="true"></span>
                        <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- ================= MODAL: EDITAR CRM DO LEAD ================= -->
        <div class="modal fade" id="modalLeadCrm" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
            data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-0 flex-column align-items-start">
                        <div class="d-flex justify-content-between align-items-start w-100 mb-3">
                            <!-- Envolvemos o Título e o Identificador numa div com flexbox e gap -->
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <h4 class="fw-bold m-0 text-dark">Editar Atendimento</h4>

                                <!-- Badge com o Identificador (só aparece se houver um selectedLead) -->
                                <span v-if="selectedLead"
                                    class="badge bg-light border text-secondary fw-medium d-flex align-items-center py-2"
                                    style="font-size: 0.85rem;">
                                    <i class="bi bi-person-fill text-primary me-1"></i> {{
                                        getLeadIdentifier(selectedLead) }}
                                </span>
                            </div>

                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <!-- Navegação de Abas -->
                        <ul class="nav nav-tabs-custom w-100 d-flex flex-nowrap"
                            style="overflow-x: auto; scrollbar-width: none; border-bottom: 2px solid #e2e8f0;">
                            <li class="nav-item flex-shrink-0">
                                <a class="nav-link d-flex align-items-center text-nowrap"
                                    :class="{ 'active': activeTab === 'responses' }" href="#"
                                    @click.prevent="activeTab = 'responses'" style="margin-bottom: -2px;">
                                    <i class="bi bi-card-checklist me-2"></i> Respostas
                                </a>
                            </li>
                            <li class="nav-item flex-shrink-0">
                                <a class="nav-link d-flex align-items-center text-nowrap"
                                    :class="{ 'active': activeTab === 'details' }" href="#"
                                    @click.prevent="activeTab = 'details'" style="margin-bottom: -2px;">
                                    <i class="bi bi-card-text me-2"></i> Atendimento
                                    <span class="badge bg-secondary rounded-pill ms-2">{{ leadAttendances.length
                                        }}</span>
                                </a>
                            </li>
                            <li class="nav-item flex-shrink-0">
                                <a class="nav-link d-flex align-items-center text-nowrap"
                                    :class="{ 'active': activeTab === 'history' }" href="#"
                                    @click.prevent="activeTab = 'history'" style="margin-bottom: -2px;">
                                    <i class="bi bi-chat-left-text me-2"></i> Histórico Interno
                                    <span class="badge bg-secondary rounded-pill ms-2">{{ leadNotes.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item flex-shrink-0">
                                <a class="nav-link d-flex align-items-center text-nowrap"
                                    :class="{ 'active': activeTab === 'products' }" href="#"
                                    @click.prevent="activeTab = 'products'" style="margin-bottom: -2px;">
                                    <i class="bi bi-box-seam me-2"></i> Produtos / Serviços
                                    <span class="badge bg-secondary rounded-pill ms-2">{{ localProductables.length
                                    }}</span>
                                </a>
                            </li>
                            <li class="nav-item flex-shrink-0">
                                <a class="nav-link d-flex align-items-center text-nowrap"
                                    :class="{ 'active': activeTab === 'audit' }" href="#"
                                    @click.prevent="activeTab = 'audit'" style="margin-bottom: -2px;">
                                    <i class="bi bi-clock-history me-2"></i> Trilha de Auditoria
                                    <span class="badge bg-secondary rounded-pill ms-2">{{ auditLogs.length }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="modal-body px-4 py-4" style="background-color: #fcfcfc;">
                        <!-- ABA 1: DETALHES DO ATENDIMENTO -->
                        <div v-if="activeTab === 'details'">

                            <!-- MODO: LISTAGEM DE ATENDIMENTOS -->
                            <div v-if="attendanceViewMode === 'list'">
                                <div class="d-flex justify-content-between align-items-center mb-4">
                                    <h6 class="fw-bold text-secondary m-0">
                                        <i class="bi bi-card-checklist me-1"></i> Histórico de Contatos
                                    </h6>
                                    <button class="btn btn-pmg-primary btn-sm px-3 shadow-sm rounded-pill"
                                        @click="openAddAttendance">
                                        <i class="bi bi-plus-lg me-1"></i> Novo Atendimento
                                    </button>
                                </div>

                                <div v-if="leadAttendances.length > 0" class="d-flex flex-column gap-3">
                                    <div v-for="att in leadAttendances" :key="att.id"
                                        class="card border-0 shadow-sm rounded-3 border-start border-4 border-primary bg-white">
                                        <div class="card-body p-3">
                                            <div class="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <span class="badge bg-light text-dark border me-2">
                                                        <i class="bi bi-calendar-check text-primary me-1"></i> {{
                                                            formatDate(att.contacted_at) }}
                                                    </span>
                                                    <span class="fw-bold text-dark small">{{ att.reason?.title || 'Sem motivo classificado' }}</span>
                                                    <span class="badge"
                                                        :class="att.is_open ? 'bg-primary-subtle text-primary border border-primary-subtle' : 'bg-success-subtle text-success border border-success-subtle'"
                                                        style="margin-left:10px;">
                                                        <i class="bi"
                                                            :class="att.is_open ? 'bi-circle-half' : 'bi-check-circle-fill'"></i>
                                                        {{ att.is_open ? 'Em Aberto' : 'Encerrado' }}
                                                    </span>
                                                </div>
                                                <div class="d-flex gap-2">
                                                    <button class="btn btn-sm btn-light border-0 text-secondary p-1"
                                                        @click="openEditAttendance(att)" title="Editar">
                                                        <i class="bi bi-pencil"></i>
                                                    </button>
                                                    <button class="btn btn-sm btn-light border-0 text-danger p-1"
                                                        @click="confirmDeleteAttendance(att.id)" title="Excluir"><i
                                                            class="bi bi-trash"></i></button>
                                                </div>
                                            </div>
                                            <p class="small text-muted mb-2" style="white-space: pre-wrap;">{{
                                                att.description }}</p>

                                            <div v-if="att.next_contact_at"
                                                class="bg-warning-subtle text-warning-emphasis px-2 py-1 rounded-2 small d-inline-block fw-medium">
                                                <i class="bi bi-alarm"></i> Retorno agendado para: {{
                                                    formatDate(att.next_contact_at) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center py-5 bg-white rounded-3 border border-dashed">
                                    <i class="bi bi-headset fs-1 text-muted opacity-25 mb-3 d-block"></i>
                                    <p class="text-muted fw-medium mb-0">Nenhum atendimento registrado para este lead.
                                    </p>
                                    <span class="small text-muted opacity-75">Clique no botão acima para iniciar o
                                        contato.</span>
                                </div>
                            </div>

                            <!-- MODO: FORMULÁRIO DE ATENDIMENTO (CRIAR/EDITAR) -->
                            <div v-else-if="attendanceViewMode === 'form'"
                                class="row g-4 bg-white p-3 rounded-4 shadow-sm border">
                                <div class="col-12 d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="fw-bold text-dark m-0">{{ attendanceForm.id ? 'Editar Atendimento' :
                                        'Registrar Novo Atendimento' }}</h6>
                                    <button class="btn btn-pmg-light" @click="attendanceViewMode = 'list'"><i
                                            class="bi bi-arrow-left mr-2"></i>&nbsp;Voltar à lista</button>
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label fw-bold text-secondary small mb-1">Data/Hora do Contato
                                        *</label>
                                    <input type="datetime-local" v-model="attendanceForm.contacted_at"
                                        class="form-control form-control-pmg bg-light">
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label fw-bold text-secondary small mb-1">Motivo / Assunto</label>
                                    <select v-model="attendanceForm.reason_id"
                                        class="form-select form-control-pmg bg-light">
                                        <option value="">Selecione...</option>
                                        <option v-for="r in reasonsList" :key="r.id" :value="r.id">{{ r.title }}
                                        </option>
                                        <option value="NEW" class="fw-bold text-primary">+ Cadastrar Novo Motivo /
                                            Assunto</option>
                                    </select>
                                </div>

                                <!-- APARECE APENAS SE "CADASTRAR NOVO" FOR SELECIONADO -->
                                <div class="col-md-12" v-if="attendanceForm.reason_id === 'NEW'">
                                    <label class="form-label fw-bold text-primary small mb-1">Qual o novo motivo /
                                        assunto? *</label>
                                    <input v-model="attendanceForm.new_reason" type="text"
                                        class="form-control form-control-pmg border-primary shadow-sm bg-light"
                                        placeholder="Ex: Dúvida Contratual">
                                </div>

                                <div class="col-12">
                                    <label class="form-label fw-bold text-secondary small mb-1">Descrição / Resumo da
                                        Conversa *</label>
                                    <textarea v-model="attendanceForm.description"
                                        class="form-control form-control-pmg bg-light" rows="4"
                                        placeholder="Descreva como foi o atendimento, as dores do lead e os acordos feitos..."></textarea>
                                </div>
                                <div class="col-12">
                                    <div class="p-3 bg-light rounded-3 border">
                                        <label class="form-label fw-bold text-secondary small mb-1"><i
                                                class="bi bi-calendar-plus me-1 text-primary"></i> Agendar Próximo
                                            Contato (Opcional)</label>
                                        <input type="datetime-local" v-model="attendanceForm.next_contact_at"
                                            class="form-control form-control-pmg border-0 shadow-sm mt-1">
                                        <span class="small text-muted mt-1 d-block">Deixe em branco se não houver
                                            necessidade de retorno agendado.</span>
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="form-check form-switch p-3 bg-light rounded-3 border d-flex align-items-center gap-2"
                                        :class="!attendanceForm.is_open ? 'border-success bg-success-subtle bg-opacity-10' : ''">

                                        <!-- A mágica: Checked = false (Encerrado), Unchecked = true (Aberto) -->
                                        <input class="form-check-input ms-0 me-2 mt-0"
                                            style="width: 2.5em; height: 1.25em; cursor: pointer;" type="checkbox"
                                            role="switch" id="switchIsOpen" v-model="attendanceForm.is_open"
                                            :true-value="false" :false-value="true">

                                        <label class="form-check-label fw-bold mb-0"
                                            :class="!attendanceForm.is_open ? 'text-success' : 'text-primary'"
                                            for="switchIsOpen" style="cursor: pointer;">
                                            {{ !attendanceForm.is_open ? 'Atendimento Encerrado (Resolvido)' : 'Deixar em Aberto (Requer acompanhamento)' }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ABA 2: HISTÓRICO INTERNO -->
                        <div v-if="activeTab === 'history'">
                            <div
                                class="alert alert-info bg-info-subtle border-info-subtle d-flex align-items-center rounded-3 p-3 mb-4">
                                <i class="bi bi-info-circle-fill text-info fs-4 me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1 text-info-emphasis">Histórico de Interações</h6>
                                    <p class="mb-0 small text-info-emphasis">Adicione anotações internas para manter o
                                        time alinhado sobre o andamento deste chamado.</p>
                                </div>
                            </div>

                            <div class="card border-0 shadow-sm rounded-4 mb-4 bg-white">
                                <div class="card-body p-4">
                                    <label class="fw-bold text-dark small mb-2">Registrar nova interação</label>
                                    <textarea v-model="content"
                                        class="form-control form-control-pmg bg-light border-0 mb-3" rows="3"
                                        placeholder="O que aconteceu agora? Descreva a interação, cobrança ou andamento..."></textarea>
                                    <div class="text-end">
                                        <button class="btn btn-pmg-primary px-4 rounded-3" @click="saveNote"
                                            :disabled="!content.trim() || loadingNote">
                                            <span v-if="loadingNote"
                                                class="spinner-border spinner-border-sm me-1"></span>
                                            <i v-else class="bi bi-send me-1"></i> Registrar Nota
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <h6 class="fw-bold text-secondary mb-3 small">Timeline</h6>
                            <div class="timeline-notes">
                                <div v-for="note in leadNotes" :key="note.id"
                                    class="card border-0 shadow-sm rounded-3 mb-3 bg-white border-start border-4 border-secondary">
                                    <div
                                        class="card-header bg-transparent border-0 pt-3 pb-0 d-flex justify-content-between align-items-center">
                                        <span class="fw-bold text-dark small">
                                            <i class="bi bi-person-circle text-primary me-1"></i> {{ note.user?.name ||
                                                'Sistema' }}
                                        </span>
                                        <span class="text-muted" style="font-size: 0.7rem;">
                                            <i class="bi bi-clock me-1"></i> {{ formatDate(note.created_at) }}
                                        </span>
                                    </div>
                                    <div class="card-body pt-2 pb-3">
                                        <p class="mb-0 small text-secondary" style="white-space: pre-wrap;">{{
                                            note.content }}</p>
                                    </div>
                                </div>
                                <div v-if="leadNotes.length === 0" class="text-center text-muted small py-4">
                                    <i class="bi bi-chat-square-dots fs-3 opacity-25 d-block mb-2"></i>
                                    Nenhuma anotação registrada ainda.
                                </div>
                            </div>
                        </div>

                        <!-- ABA 3: PRODUTOS E SERVIÇOS -->
                        <div v-if="activeTab === 'products'">

                            <!-- Bloco de Adição (Fixo no topo da aba) -->
                           <div class="bg-light p-3 rounded-4 mb-3 border shadow-sm">
    <label class="form-label fw-bold text-secondary small mb-2">
        <i class="bi bi-plus-circle me-1"></i> Adicionar novo vínculo ao Lead
    </label>
    <div class="row g-2">
        <div class="col-md-3">
            <select v-model="linkType" class="form-select form-control-pmg bg-white" @change="onLinkTypeChange">
                <option value="App\Models\Product">Produto</option>
                <option value="App\Models\Service">Serviço</option>
            </select>
        </div>
        <div class="col-md-9 position-relative">
            <input type="text" v-model="linkQuery" @input="onLinkInput"
                @focus="showLinkDrop = true" @blur="hideLinkDrop"
                class="form-control form-control-pmg bg-white"
                :placeholder="linkType === 'App\\Models\\Product' ? 'Buscar produto pelo nome...' : 'Buscar serviço pela descrição...'">

            <!-- Autocomplete Dropdown -->
            <div v-if="showLinkDrop && linkResults.length > 0"
                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                style="z-index: 1060; max-height: 250px; overflow-y: auto;">
                <ul class="list-unstyled mb-0">
                    <li v-for="it in linkResults" :key="it.id"
                        @mousedown="selectLinkItem(it)"
                        class="p-3 autocomplete-item border-bottom cursor-pointer d-flex justify-content-between align-items-center">
                        <div>
                            <div class="fw-bold text-dark">{{ it.name ?? it.description }}</div>
                            <div class="small text-muted">ID: {{ it.id.substring(0, 8) }}</div>
                        </div>
                        <i class="bi bi-plus-lg text-primary"></i>
                    </li>
                </ul>
            </div>
        </div>

        <!-- CAMPO OPCIONAL DE OBSERVAÇÃO PRÉVIA -->
        <div class="col-12 mt-2" v-if="selectedTempItem">
            <div class="p-2 bg-white rounded-3 border d-flex align-items-center gap-2">
                <span class="badge bg-primary-subtle text-primary fw-bold px-3 py-2">
                    {{ selectedTempItem.name ?? selectedTempItem.description }}
                </span>
                <input type="text" v-model="linkObservation" class="form-control form-control-sm border-0" 
                    placeholder="Digite uma observação inicial para este vínculo (opcional)...">
                <button class="btn btn-sm btn-pmg-primary px-3 text-nowrap" @click="confirmAddLink">
                    <i class="bi bi-check-lg me-1"></i> Vincular
                </button>
                <button class="btn btn-sm btn-light text-danger border-0" @click="selectedTempItem = null">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
        </div>
    </div>
</div>

                            <!-- ÁREA COM SCROLL PARA AS LISTAS -->
                            <div class="pe-2"
                                style="max-height: 45vh; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin;">

                                <!-- Listagem: PRODUTOS -->
                                <h6 class="fw-bold text-dark mb-3 mt-2"><i class="bi bi-box-fill me-2 text-primary"></i>
                                    Produtos ({{ linkedProducts.length }})</h6>
                                <div class="d-flex flex-column gap-2 mb-4">
                                    <div v-for="item in linkedProducts" :key="item.productable_id"
                                        class="card border-0 shadow-sm border-start border-4 border-primary rounded-3 bg-white">
                                        <div class="card-body p-3 row align-items-center g-3">
                                            <div class="col-md-4">
                                                <div class="fw-bold text-dark mb-1 text-truncate"
                                                    :title="item.productable?.name || item.productable?.description">
                                                    {{ item.productable?.name || item.productable?.description || 'Item indisponível' }}
                                                </div>

                                                <div class="mt-2">
                                                    <select v-model="item.status"
                                                        class="form-select form-select-sm shadow-sm fw-bold border"
                                                        :class="getProductStatusColor(item.status)"
                                                        style="max-width: 180px; font-size: 0.8rem;">
                                                        <option value="nao_negociado" class="bg-white text-dark">Não Negociado</option>
                                                        <option value="em_negociacao" class="bg-white text-dark">Em Negociação</option>
                                                        <option value="fechado" class="bg-white text-dark">Fechado</option>
                                                        <option value="desistencia" class="bg-white text-dark">Desistência</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <label class="small text-muted fw-bold d-block mb-1">Data Início</label>
                                                <input type="date" v-model="item.start_date" class="form-control form-control-sm form-control-pmg">
                                            </div>

                                            <div class="col-md-2">
                                                <label class="small text-muted fw-bold d-block mb-1">Data Fim</label>
                                                <input type="date" v-model="item.end_date" class="form-control form-control-sm form-control-pmg">
                                            </div>

                                            <div class="col-md-3">
                                                <label class="small fw-bold d-block mb-1 text-warning-emphasis">
                                                    <i class="bi bi-clock-history me-1"></i> Retorno Agendado
                                                </label>
                                                <input type="date" v-model="item.return_date"
                                                    class="form-control form-control-sm border-warning-subtle shadow-sm bg-warning-subtle bg-opacity-10"
                                                    style="padding: 12px 8px;">
                                            </div>

                                            <div class="col-md-1 text-end">
                                                <button class="btn btn-sm btn-light text-danger border-0 w-100"
                                                    @click="removeLinkItem(item)" title="Remover Vínculo">
                                                    <i class="bi bi-trash fs-5"></i>
                                                </button>
                                            </div>

                                            <!-- CAMPO DE OBSERVAÇÃO -->
                                            <div class="col-12 mt-2 pt-2 border-top">
                                                <label class="small text-muted fw-bold d-block mb-1">
                                                    <i class="bi bi-card-text me-1 text-primary"></i> Observação do Vínculo
                                                </label>
                                                <textarea v-model="item.observation" class="form-control form-control-sm form-control-pmg bg-light" rows="2" placeholder="Anote detalhes de negociação, restrições ou observações específicas deste item..."></textarea>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-if="linkedProducts.length === 0"
                                        class="text-center py-3 bg-light rounded-3 border border-dashed text-muted small">
                                        Nenhum produto vinculado.
                                    </div>
                                </div>

                                <!-- Listagem: SERVIÇOS -->
                                <h6 class="fw-bold text-dark mb-3 border-top pt-3"><i
                                        class="bi bi-tools me-2 text-primary"></i> Serviços ({{ linkedServices.length
                                        }})</h6>
                                <div class="d-flex flex-column gap-2 mb-2">
                                    <div v-for="item in linkedServices" :key="item.productable_id"
                                        class="card border-0 shadow-sm border-start border-4 border-info rounded-3 bg-white">
                                        <div class="card-body p-3 row align-items-center g-3">
                                            <div class="col-md-4">
                                                <div class="fw-bold text-dark mb-1 text-truncate"
                                                    :title="item.productable?.name || item.productable?.description">
                                                    {{ item.productable?.name || item.productable?.description || 'Item indisponível' }}
                                                </div>

                                                <div class="mt-2">
                                                    <select v-model="item.status"
                                                        class="form-select form-select-sm shadow-sm fw-bold border"
                                                        :class="getProductStatusColor(item.status)"
                                                        style="max-width: 180px; font-size: 0.8rem;">
                                                        <option value="nao_negociado" class="bg-white text-dark">Não Negociado</option>
                                                        <option value="em_negociacao" class="bg-white text-dark">Em Negociação</option>
                                                        <option value="fechado" class="bg-white text-dark">Fechado</option>
                                                        <option value="desistencia" class="bg-white text-dark">Desistência</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <label class="small text-muted fw-bold d-block mb-1">Data Início</label>
                                                <input type="date" v-model="item.start_date" class="form-control form-control-sm form-control-pmg">
                                            </div>

                                            <div class="col-md-2">
                                                <label class="small text-muted fw-bold d-block mb-1">Data Fim</label>
                                                <input type="date" v-model="item.end_date" class="form-control form-control-sm form-control-pmg">
                                            </div>

                                            <div class="col-md-3">
                                                <label class="small fw-bold d-block mb-1 text-warning-emphasis">
                                                    <i class="bi bi-clock-history me-1"></i> Retorno Agendado
                                                </label>
                                                <input type="date" v-model="item.return_date"
                                                    class="form-control form-control-sm border-warning-subtle shadow-sm bg-warning-subtle bg-opacity-10"
                                                    style="padding: 12px 8px;">
                                            </div>

                                            <div class="col-md-1 text-end">
                                                <button class="btn btn-sm btn-light text-danger border-0 w-100"
                                                    @click="removeLinkItem(item)" title="Remover Vínculo">
                                                    <i class="bi bi-trash fs-5"></i>
                                                </button>
                                            </div>

                                            <!-- CAMPO DE OBSERVAÇÃO -->
                                            <div class="col-12 mt-2 pt-2 border-top">
                                                <label class="small text-muted fw-bold d-block mb-1">
                                                    <i class="bi bi-card-text me-1 text-primary"></i> Observação do Vínculo
                                                </label>
                                                <textarea v-model="item.observation" class="form-control form-control-sm form-control-pmg bg-light" rows="2" placeholder="Anote detalhes de negociação, restrições ou observações específicas deste item..."></textarea>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-if="linkedServices.length === 0"
                                        class="text-center py-3 bg-light rounded-3 border border-dashed text-muted small">
                                        Nenhum serviço vinculado.
                                    </div>
                                </div>

                            </div> <!-- Fim da área com scroll -->
                        </div>

                        <!-- ABA 4: TRILHA DE AUDITORIA (LOGS) -->
                        <div v-if="activeTab === 'audit'" class="bg-white p-4 rounded-4 shadow-sm border">
                            <h6 class="fw-bold text-dark mb-4"><i class="bi bi-journal-text text-primary me-2"></i>
                                Histórico de Alterações do Lead</h6>

                            <div class="audit-scroll-container" style="max-height: 50vh;">
                                <div v-if="auditLogs.length > 0" class="timeline">
                                    <div v-for="log in auditLogs" :key="log.id" class="timeline-item pb-4">
                                        <div class="timeline-marker"></div>

                                        <div class="ms-4">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="fw-bold text-dark small">
                                                    <i class="bi bi-person-circle me-1"></i> {{ log.user?.name ||
                                                        'Sistema' }}
                                                </span>
                                                <span class="text-muted" style="font-size: 0.7rem;">
                                                    {{ formatDate(log.created_at) }}
                                                </span>
                                            </div>

                                            <span class="badge mb-2 mt-1" :class="getActionBadge(log.action).class"
                                                style="font-size: 0.6rem; text-transform: uppercase;">
                                                {{ getActionBadge(log.action).text }}
                                            </span>

                                            <div v-if="log.changes"
                                                class="bg-light p-3 rounded-3 border-start border-3 border-primary shadow-sm">

                                                <!-- DETALHAMENTO DE PRODUTOS E SERVIÇOS SINCRONIZADOS -->
                                                <div v-if="log.action === 'products_synced'" class="small text-dark">

                                                    <!-- Adicionados -->
                                                    <div v-if="log.changes.added && log.changes.added.length > 0"
                                                        class="mb-2">
                                                        <span
                                                            class="fw-bold text-success d-flex align-items-center mb-1">
                                                            <i class="bi bi-plus-circle-fill me-1"></i> Adicionado(s):
                                                        </span>
                                                        <ul class="mb-0 ps-3 text-secondary">
                                                            <li v-for="addName in log.changes.added" :key="addName"
                                                                class="fw-medium">{{ addName }}</li>
                                                        </ul>
                                                    </div>

                                                    <!-- Removidos -->
                                                    <div v-if="log.changes.removed && log.changes.removed.length > 0"
                                                        class="mb-2">
                                                        <span
                                                            class="fw-bold text-danger d-flex align-items-center mb-1">
                                                            <i class="bi bi-dash-circle-fill me-1"></i> Removido(s):
                                                        </span>
                                                        <ul class="mb-0 ps-3 text-secondary">
                                                            <li v-for="remName in log.changes.removed" :key="remName"
                                                                class="fw-medium text-decoration-line-through">{{
                                                                    remName }}</li>
                                                        </ul>
                                                    </div>

                                                    <!-- Atualizados / Modificados -->
                                                    <div v-if="log.changes.updated && log.changes.updated.length > 0">
                                                        <span
                                                            class="fw-bold text-primary d-flex align-items-center mb-1">
                                                            <i class="bi bi-pencil-square me-1"></i> Alteração em
                                                            Vínculo(s):
                                                        </span>
                                                        <div v-for="upd in log.changes.updated" :key="upd.name"
                                                            class="ps-2 mt-1 mb-2 border-start border-2 border-primary-subtle">
                                                            <div class="fw-bold text-dark">{{ upd.name }}</div>
                                                            <div v-for="(mod, field) in upd.modifications" :key="field"
                                                                class="text-muted mt-1" style="font-size: 0.75rem;">
                                                                <span class="text-uppercase fw-semibold">{{
                                                                    translateProductField(field) }}:</span>
                                                                <span
                                                                    class="text-danger text-decoration-line-through ms-1">{{
                                                                        mod.old }}</span> ➔
                                                                <span class="text-success fw-bold">{{ mod.new }}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <!-- ITERAÇÃO NORMAL PARA OS DEMAIS CAMPOS -->
                                                <template v-else>
                                                    <div v-for="(changeData, field) in log.changes" :key="field"
                                                        class="mb-2 border-bottom border-white pb-1 last-child-no-border">

                                                        <span class="d-block small text-muted text-uppercase fw-bold"
                                                            style="font-size: 0.55rem;">
                                                            Campo: {{ translateField(field) }}
                                                        </span>

                                                        <div class="d-flex align-items-center gap-2 small">
                                                            <span
                                                                class="text-danger text-decoration-line-through text-truncate"
                                                                style="max-width: 45%;">
                                                                {{ formatValue(field, changeData.old) }}
                                                            </span>
                                                            <i class="bi bi-arrow-right text-muted"></i>
                                                            <span class="text-success fw-bold text-truncate"
                                                                style="max-width: 45%;">
                                                                {{ formatValue(field, changeData.new) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </template>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center py-5">
                                    <i class="bi bi-journal-x fs-1 text-muted opacity-25"></i>
                                    <p class="text-muted mt-3 mb-0">Nenhum histórico de alterações encontrado para este
                                        lead.</p>
                                </div>
                            </div>
                        </div>
                        <!-- ABA 5: RESPOSTAS DO FORMULÁRIO -->
                        <div v-if="activeTab === 'responses'" class="bg-white p-4 rounded-4 shadow-sm border">
                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <h6 class="fw-bold text-dark mb-0">
                                    <i class="bi bi-card-text text-primary me-2"></i> Respostas preenchidas pelo Lead
                                </h6>
                                <!-- Botão de Editar (Só aparece se não estiver no modo de edição) -->
                                <button v-if="!isEditingResponses" class="btn btn-sm btn-pmg-light shadow-sm" @click="startEditingResponses">
                                    <i class="bi bi-pencil me-1"></i> Editar Respostas
                                </button>
                            </div>

                            <!-- Container com scroll vertical limpo -->
                            <div style="max-height: 50vh; overflow-y: auto; overflow-x: hidden;" class="pe-2">
                                <div class="row g-3 m-0">
                                    <div class="col-md-12 ps-0" v-for="field in pageInfo?.fields" :key="field.id">
                                        <div class="bg-light rounded-3 p-3 border border-light h-100" :class="{ 'border-primary-subtle bg-primary-subtle bg-opacity-10': isEditingResponses }">
                                            <label class="small fw-bold d-block mb-1" :class="isEditingResponses ? 'text-primary' : 'text-muted'">
                                                {{ field.label || field.name }}
                                            </label>
                                            
                                            <!-- Modo de Leitura (Estático) -->
                                            <div v-if="!isEditingResponses" class="fw-medium text-dark text-break">
                                                {{ getResponseValue(selectedLead, field) }}
                                            </div>

                                            <!-- Modo de Edição (Inputs) -->
                                            <div v-else>
                                                <input type="text" v-model="editableResponses[field.name || field.label]" class="form-control form-control-sm form-control-pmg bg-white shadow-sm border-0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Botões de Ação para Salvar a Edição -->
                            <div v-if="isEditingResponses" class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                                <button class="btn btn-pmg-light px-4 fw-bold" @click="cancelEditResponses" :disabled="loadingSaveResponses">
                                    Cancelar
                                </button>
                                <button class="btn btn-pmg-primary px-4 fw-bold shadow-sm" @click="saveLeadResponses" :disabled="loadingSaveResponses">
                                    <span v-if="loadingSaveResponses" class="spinner-border spinner-border-sm me-2"></span>
                                    <i v-else class="bi bi-check-lg me-1"></i> Atualizar Respostas
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- FOOTER DO MODAL -->
                    <div class="modal-footer border-0 pb-4 px-4 bg-white rounded-bottom-4">

                        <!-- Botões da Aba de Detalhes -->
                        <template
                            v-if="activeTab === 'history' || activeTab === 'audit' || activeTab === 'details' || activeTab === 'responses'">
                            <div v-if="attendanceViewMode === 'list'" class="w-100 d-flex justify-content-end">
                                <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Fechar</button>
                            </div>
                            <div v-if="attendanceViewMode === 'form'" class="w-100 d-flex justify-content-end gap-2">
                                <button class="btn btn-pmg-light" @click="attendanceViewMode = 'list'">Cancelar</button>
                                <button class="btn btn-pmg-primary px-4" @click="saveAttendance"
                                    :disabled="loadingAttendanceSave || !attendanceForm.description || !attendanceForm.contacted_at || (attendanceForm.reason_id === 'NEW' && !attendanceForm.new_reason)">
                                    <span v-if="loadingAttendanceSave"
                                        class="spinner-border spinner-border-sm me-1"></span> Salvar Atendimento
                                </button>
                            </div>
                        </template>

                        <!-- Botões da Aba de Produtos e Serviços -->
                        <template v-if="activeTab === 'products'">
                            <div class="w-100 d-flex justify-content-end gap-2">
                                <button class="btn btn-pmg-light" data-bs-dismiss="modal">Fechar</button>
                                <button class="btn btn-pmg-primary px-4" @click="syncProductables"
                                    :disabled="loadingSyncProductables || localProductables.length === 0">
                                    <span v-if="loadingSyncProductables"
                                        class="spinner-border spinner-border-sm me-1"></span> Sincronizar Vínculos
                                </button>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
        </div>

        <!-- ================= MODAL: TRILHA DE AUDITORIA ================= -->
        <div class="modal fade" id="modalAuditTimeline" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <div>
                            <h5 class="fw-bold m-0 text-dark">Trilha de Auditoria</h5>
                            <p class="text-muted small mb-0" v-if="selectedLeadAudit">
                                Lead ID: <strong>#{{ selectedLeadAudit.id?.substring(0, 8) }}</strong>
                            </p>
                        </div>
                        <button type="button" class="btn-close" @click="closeAuditModal"></button>
                    </div>
                    <div class="modal-body p-4">
                        <div class="audit-scroll-container">
                            <div v-if="auditLogs.length > 0" class="timeline">
                                <div v-for="log in auditLogs" :key="log.id" class="timeline-item pb-4">
                                    <div class="timeline-marker"></div>

                                    <div class="ms-4">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span class="fw-bold text-dark small">
                                                <i class="bi bi-person-circle me-1"></i> {{ log.user?.name || 'Sistema'
                                                }}
                                            </span>
                                            <span class="text-muted" style="font-size: 0.7rem;">
                                                {{ formatDate(log.created_at) }}
                                            </span>
                                        </div>

                                        <span class="badge mb-2 mt-1"
                                            :class="log.action === 'updated' ? 'bg-primary-subtle text-primary' : 'bg-success-subtle text-success'"
                                            style="font-size: 0.6rem; text-transform: uppercase;">
                                            {{ log.action === 'updated' ? 'Edição' : 'Criação' }}
                                        </span>

                                        <div v-if="log.changes"
                                            class="bg-light p-2 rounded-3 border-start border-3 border-primary shadow-sm">
                                            <!-- Iteração sobre os campos modificados -->
                                            <div v-for="(changeData, field) in log.changes" :key="field"
                                                class="mb-2 border-bottom border-white pb-1 last-child-no-border">

                                                <span class="d-block small text-muted text-uppercase fw-bold"
                                                    style="font-size: 0.55rem;">
                                                    Campo: {{ translateField(field) }}
                                                </span>

                                                <div class="d-flex align-items-center gap-2 small">
                                                    <span class="text-danger text-decoration-line-through">
                                                        {{ formatValue(field, changeData.old) }}
                                                    </span>
                                                    <i class="bi bi-arrow-right text-muted"></i>
                                                    <span class="text-success fw-bold">
                                                        {{ formatValue(field, changeData.new) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center py-5">
                                <i class="bi bi-journal-x fs-1 text-muted opacity-25"></i>
                                <p class="text-muted mt-3">Nenhum histórico encontrado para este item.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ================= DEMAIS MODAIS ================= -->
        <div class="modal fade" id="modalGeneralReport" tabindex="-1" aria-hidden="true" ref="modalGeneralReport">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <h5 class="fw-bold m-0 text-dark">Filtros de Exportação</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body p-4">

                        <!-- FILTROS DO LEAD -->
                        <h6 class="fw-bold text-dark mb-2 small text-uppercase"><i
                                class="bi bi-person-lines-fill text-primary me-2"></i> Filtros do Lead</h6>
                        <div class="row g-2">
                            <div class="col-md-12">
                                <label class="form-label fw-bold text-secondary small mb-1">Buscar (Nome, Respostas,
                                    etc)</label>
                                <div class="input-group">
                                    <span class="input-group-text bg-light border-end-0"><i
                                            class="bi bi-search text-muted"></i></span>
                                    <input v-model="filter.search" type="text"
                                        class="form-control form-control-pmg bg-white border-start-0 ps-0"
                                        placeholder="Digite um termo...">
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-1"> <!-- g-2 para reduzir o espaçamento vertical entre os campos -->

                            <div class="col-md-4">
                                <label class="form-label fw-bold text-muted small mb-1">Status do Lead</label>
                                <select v-model="reportFilters.status" class="form-select form-control-pmg bg-light">
                                    <option value="">Todos os Status</option>
                                    <option v-for="col in kanbanColumns" :key="col.id" :value="col.id">{{ col.title }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label small fw-bold text-muted mb-1">Criação (De)</label>
                                <input type="date" v-model="reportFilters.start_date"
                                    class="form-control form-control-pmg bg-light px-2">
                            </div>
                            <div class="col-md-2">
                                <label class="form-label small fw-bold text-muted mb-1">Criação (Até)</label>
                                <input type="date" v-model="reportFilters.end_date"
                                    class="form-control form-control-pmg bg-light px-2">
                            </div>
                            <div class="col-md-2">
                                <label class="form-label fw-bold text-muted small mb-1">Contato (De)</label>
                                <input v-model="reportFilters.contacted_start_date" type="date"
                                    class="form-control form-control-pmg bg-light px-2">
                            </div>
                            <div class="col-md-2">
                                <label class="form-label fw-bold text-muted small mb-1">Contato (Até)</label>
                                <input v-model="reportFilters.contacted_end_date" type="date"
                                    class="form-control form-control-pmg bg-light px-2">
                            </div>
                        </div>
                        <div class="row g-2 mt-1">
                            <div class="col-md-6">
                                <label class="form-label fw-bold text-secondary small mb-1">Retorno Atendimento
                                    (De)</label>
                                <input v-model="filter.attendance_return_start_date" type="date"
                                    class="form-control form-control-pmg bg-white">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold text-secondary small mb-1">Retorno Atendimento
                                    (Até)</label>
                                <input v-model="filter.attendance_return_end_date" type="date"
                                    class="form-control form-control-pmg bg-white">
                            </div>
                        </div>

                        <!-- FILTROS DE PRODUTOS E SERVIÇOS -->
                        <div
                            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-3 pt-3 border-top gap-2 mb-2">
                            <h6 class="fw-bold text-dark m-0 small text-uppercase">
                                <i class="bi bi-box-seam-fill text-primary me-2"></i> Filtros de Produtos e Serviços
                            </h6>

                            <!-- Dropdown de Precisão das Datas -->
                            <div class="dropdown">
                                <button
                                    class="btn btn-pmg-light dropdown-toggle px-3 py-1 shadow-sm rounded-3 fw-bold text-secondary bg-light"
                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                    style="font-size: 0.8rem; height: auto;">
                                    <i class="bi bi-calendar-range text-primary me-1"></i>
                                    Precisão: <span class="text-dark ms-1">
                                        {{
                                            reportFilters.date_precision === 'full' ? 'Dia/Mês/Ano' :
                                                (reportFilters.date_precision === 'month_year' ? 'Mês/Ano' :
                                                    (reportFilters.date_precision === 'month' ? 'Apenas Mês' : 'Apenas Dia'))
                                        }}
                                    </span>
                                </button>
                                <ul class="dropdown-menu shadow border-0 py-2 rounded-3"
                                    style="font-size: 0.85rem; z-index: 1070;">
                                    <li>
                                        <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Filtrar por
                                        </h6>
                                    </li>
                                    <li><a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                            @click.prevent="reportFilters.date_precision = 'full'"
                                            :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'full' }"><i
                                                class="bi bi-calendar-check text-success fs-6"></i> Data Completa
                                            (Dia/Mês/Ano)</a></li>
                                    <li><a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                            @click.prevent="reportFilters.date_precision = 'month_year'"
                                            :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'month_year' }"><i
                                                class="bi bi-calendar-month text-warning fs-6"></i> Apenas Mês/Ano</a>
                                    </li>
                                    <li><a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                            @click.prevent="reportFilters.date_precision = 'month'"
                                            :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'month' }"><i
                                                class="bi bi-calendar2-week text-primary fs-6"></i> Apenas o Mês</a>
                                    </li>
                                    <li><a class="dropdown-item py-2 d-flex align-items-center gap-2" href="#"
                                            @click.prevent="reportFilters.date_precision = 'day'"
                                            :class="{ 'bg-light fw-bold text-primary': reportFilters.date_precision === 'day' }"><i
                                                class="bi bi-calendar-day text-info fs-6"></i> Apenas o Dia</a></li>
                                </ul>
                            </div>
                        </div>

                        <!-- CAMPOS DE FILTRAGEM (Compactados em 2 linhas) -->
                        <div class="row g-2">
                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Tipo de Item</label>
                                <select v-model="reportProductType" @change="onReportProductTypeChange"
                                    class="form-select form-control-pmg bg-light">
                                    <option value="App\Models\Product">Produto</option>
                                    <option value="App\Models\Service">Serviço</option>
                                </select>
                            </div>

                            <div class="col-md-6 position-relative">
                                <label class="form-label fw-bold text-muted small mb-1">Buscar Produto/Serviço</label>
                                <div class="input-group">
                                    <input type="text" v-model="reportProductQuery" @input="onReportProductInput"
                                        @focus="showReportProductDrop = true" @blur="hideReportProductDrop"
                                        class="form-control form-control-pmg bg-light"
                                        :placeholder="reportProductType === 'App\\Models\\Product' ? 'Buscar produto...' : 'Buscar serviço...'"
                                        :disabled="!!selectedReportProduct">

                                    <button v-if="selectedReportProduct"
                                        class="btn btn-light border bg-white text-danger px-3" type="button"
                                        @click="clearReportProduct">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>

                                <!-- Autocomplete Dropdown do Relatório -->
                                <div v-if="showReportProductDrop && reportProductResults.length > 0"
                                    class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                    style="z-index: 1070; max-height: 250px; overflow-y: auto;">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="it in reportProductResults" :key="it.id"
                                            @mousedown="selectReportProduct(it)"
                                            class="p-3 autocomplete-item border-bottom cursor-pointer d-flex justify-content-between align-items-center">
                                            <div class="fw-bold text-dark">{{ it.name ?? it.description }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Status da Venda</label>
                                <select v-model="reportFilters.item_status"
                                    class="form-select form-control-pmg bg-light">
                                    <option value="">Todos</option>
                                    <option value="nao_negociado">Não Negociado</option>
                                    <option value="em_negociacao">Em Negociação</option>
                                    <option value="fechado">Fechado</option>
                                    <option value="desistencia">Desistência</option>
                                </select>
                            </div>
                        </div>

                        <div class="row g-2 mt-1">
                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Vigência (De)</label>
                                <input v-model="reportFilters.item_start_date" type="date"
                                    class="form-control form-control-pmg bg-light">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Vigência (Até)</label>
                                <input v-model="reportFilters.item_end_date" type="date"
                                    class="form-control form-control-pmg bg-light">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Retorno Agendado (De)</label>
                                <input v-model="reportFilters.item_return_start_date" type="date"
                                    class="form-control form-control-pmg bg-light">
                            </div>
                            <div class="col-md-3">
                                <label class="form-label fw-bold text-muted small mb-1">Retorno Agendado (Até)</label>
                                <input v-model="reportFilters.item_return_end_date" type="date"
                                    class="form-control form-control-pmg bg-light">
                            </div>
                        </div>

                        <!-- TIPO DE RELATÓRIO -->
                        <div class="col-12 mt-3 pt-3 border-top">
                            <label class="form-label small fw-bold text-dark w-100 pb-1 mb-1">Formato do
                                Relatório</label>

                            <!-- Opções principais em linha (horizontal) -->
                            <div class="d-flex flex-wrap gap-4 align-items-center">
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="radio" v-model="reportFilters.report_type"
                                        value="resumido" id="typeResumido">
                                    <label class="form-check-label fw-medium text-dark" for="typeResumido">
                                        <i class="bi bi-card-text text-secondary me-1"></i> Resumido
                                    </label>
                                </div>
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="radio" v-model="reportFilters.report_type"
                                        value="completo" id="typeCompleto">
                                    <label class="form-check-label fw-medium text-dark" for="typeCompleto">
                                        <i class="bi bi-collection text-primary me-1"></i> Completo
                                    </label>
                                </div>
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="radio" v-model="reportFilters.report_type"
                                        value="estatistico" id="typeEstatistico">
                                    <label class="form-check-label fw-medium text-dark" for="typeEstatistico">
                                        <i class="bi bi-pie-chart-fill text-success me-1"></i> Estatístico
                                    </label>
                                </div>
                            </div>

                            <!-- Opções condicionais em blocos compactos -->
                            <div v-if="reportFilters.report_type === 'estatistico'"
                                class="mt-2 p-2 bg-success-subtle bg-opacity-25 rounded-3 border border-success-subtle d-flex align-items-center gap-2">
                                <label class="form-label small fw-bold text-success mb-0 m-0">Tipo de Gráfico:</label>
                                <select v-model="reportFilters.chart_type" class="form-select form-select-sm bg-white"
                                    style="width: auto;">
                                    <option value="pie">Pizza (Padrão)</option>
                                    <option value="bar">Barra Vertical</option>
                                    <option value="horizontalBar">Barra Horizontal</option>
                                </select>
                            </div>

                            <div v-if="reportFilters.report_type === 'completo'"
                                class="mt-2 p-2 bg-primary-subtle bg-opacity-10 rounded-3 border border-primary-subtle d-flex flex-wrap gap-3">
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="checkbox"
                                        v-model="reportFilters.include_attendances" id="incAttendances">
                                    <label class="form-check-label small fw-bold text-secondary mt-1"
                                        for="incAttendances">Histórico</label>
                                </div>
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="checkbox"
                                        v-model="reportFilters.include_notes" id="incNotes">
                                    <label class="form-check-label small fw-bold text-secondary mt-1"
                                        for="incNotes">Anotações</label>
                                </div>
                                <div class="form-check m-0">
                                    <input class="form-check-input" type="checkbox"
                                        v-model="reportFilters.include_products" id="incProducts">
                                    <label class="form-check-label small fw-bold text-secondary mt-1"
                                        for="incProducts">Vínculos</label>
                                </div>
                            </div>
                        </div>

                        <!-- BOTÃO GERAR -->
                        <div class="mt-4 pt-2">
                            <button class="btn btn-pmg-primary w-100 py-3 fw-bold shadow-sm"
                                @click="generateReport(exportFormat)" :disabled="loadingReport || !isReportValid">
                                <template v-if="loadingReport">
                                    <span class="spinner-border spinner-border-sm me-2"></span>PROCESSANDO...
                                </template>
                                <template v-else>
                                    <i :class="exportFormat === 'pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-excel-fill'"
                                        class="me-2 fs-5"></i>
                                    {{ exportFormat === 'pdf' ? 'GERAR RELATÓRIO PDF' : 'EXPORTAR PLANILHA XLSX' }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="leadDetailsModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-0 flex-column align-items-start">
                        <div class="d-flex justify-content-between w-100 mb-2">
                            <h5 class="fw-bold m-0 text-dark">Detalhes do Lead #{{ selectedLead?.id?.substring(0, 8) }}
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <div class="modal-body p-4" v-if="selectedLead">
                        <h6 class="fw-bold text-muted small text-uppercase mb-3">
                            <i class="bi bi-card-text me-1"></i> Respostas
                        </h6>
                        <div class="row g-3">
                            <div class="col-12" v-for="field in pageInfo?.fields" :key="field.id">
                                <div class="bg-light rounded-3 p-3 border border-light">
                                    <label class="small text-muted fw-bold d-block mb-1">{{ field.label || field.name
                                        }}</label>
                                    <div class="fw-medium text-dark text-break">{{ getResponseValue(selectedLead, field)
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3"><i class="bi bi-exclamation-triangle-fill fs-1"></i></div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">Excluir este registro permanentemente?</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalFunnel" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <h5 class="fw-bold m-0 text-dark">
                        <i class="bi bi-funnel-fill text-primary me-2"></i> Funil de Conversão
                    </h5>
                    <button type="button" class="btn-close" @click="closeFunnelModal"></button>
                </div>
                <div class="modal-body p-4 bg-light rounded-bottom-4">
                    <div class="text-center mb-4">
                        <h6 class="fw-bold text-muted small text-uppercase">Total de Leads Captados</h6>
                        <h2 class="fw-bold text-dark mb-0">{{ allLeadsMetrics.length }}</h2>
                    </div>

                    <div class="funnel-container text-center mt-4">
                        <div v-for="(step, index) in funnelData" :key="step.id">
                            <!-- Bloco da Etapa -->
                            <div class="card border-0 shadow-sm mx-auto mb-1 funnel-step transition-all"
                                :class="step.cardClass" :style="{ width: Math.max(40, 100 - (index * 12)) + '%' }">
                                <div
                                    class="card-body p-3 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
                                    <span class="fw-bold small text-uppercase">{{ step.title }}</span>
                                    <span class="badge bg-white text-dark shadow-sm px-3 py-2 rounded-pill">
                                        {{ step.count }} <span class="fw-normal text-muted ms-1">({{ step.overallRate
                                        }}%)</span>
                                    </span>
                                </div>
                            </div>

                            <!-- Seta de Conversão para a próxima etapa -->
                            <div v-if="index < funnelData.length - 1"
                                class="text-muted small fw-bold mb-1 d-flex flex-column align-items-center">
                                <div style="height: 15px; width: 2px; background-color: #cbd5e1;"></div>
                                <span class="badge bg-white text-secondary border shadow-sm my-1"
                                    style="font-size: 0.7rem;">
                                    Conversão: <span class="text-success fw-bold">{{ funnelData[index +
                                        1]?.conversionRate
                                    }}%</span>
                                </span>
                                <div style="height: 15px; width: 2px; background-color: #cbd5e1;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmDeleteAttendanceModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" style="z-index: 1070;">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-danger mb-3"><i class="bi bi-exclamation-triangle-fill fs-1"></i></div>
                    <h5 class="fw-bold">Tem certeza?</h5>
                    <p class="text-muted small">Excluir este atendimento permanentemente?</p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                    <button class="btn btn-danger px-4 rounded-3" @click="executeAttendanceDeletion">Confirmar</button>
                </div>
            </div>
        </div>
    </div>
    <!-- ================= MODAL: AGENDA DE TAREFAS / RETORNOS ================= -->
    <div class="modal fade" id="modalFollowUps" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered"> <!-- Removido o modal-lg para ajustar melhor -->
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <div class="d-flex align-items-center gap-2">
                        <div class="bg-warning-subtle text-warning-emphasis p-2 rounded-3 fs-5">
                            <i class="bi bi-alarm-fill"></i>
                        </div>
                        <div>
                            <h5 class="fw-bold m-0 text-dark">Agenda de Retornos e Tarefas</h5>
                            <p class="text-muted small mb-0">Contatos agendados para hoje ou em atraso</p>
                        </div>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body p-4 bg-light rounded-bottom-4">
                    <!-- Adicionado overflow-x: hidden para evitar qualquer barra lateral -->
                    <div style="max-height: 55vh; overflow-y: auto; overflow-x: hidden;" class="pe-1">
                        <div class="row g-3 m-0" v-if="todayFollowUps.length > 0">
                            <!-- Alterado para col-12 para ocupar a largura correta de forma vertical e fluida -->
                            <div class="col-12 ps-0 pe-0" v-for="att in todayFollowUps" :key="att.id">
                                <!-- Card com borda dinâmica: Vermelho se em atraso, Amarelo se for para hoje -->
                                <div class="card border-0 shadow-sm p-3 bg-white h-100 rounded-3 border-start border-4"
                                    :class="isOverdue(att.next_contact_at) ? 'border-danger' : 'border-warning'">

                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <div class="d-flex align-items-center flex-wrap gap-2">
                                            <span class="badge bg-light text-dark border">
                                                <i class="bi bi-calendar-check text-primary me-1"></i> {{
                                                    formatDate(att.contacted_at) }}
                                            </span>
                                            <span class="fw-bold text-dark small">{{ att.reason?.title || 'Sem motivo classificado' }}</span>
                                            <span class="badge"
                                                :class="att.is_open ? 'bg-primary-subtle text-primary border border-primary-subtle' : 'bg-success-subtle text-success border border-success-subtle'">
                                                <i class="bi"
                                                    :class="att.is_open ? 'bi-circle-half' : 'bi-check-circle-fill'"></i>
                                                {{ att.is_open ? 'Em Aberto' : 'Encerrado' }}
                                            </span>
                                        </div>
                                        <div class="d-flex gap-2">
                                            <button class="btn btn-sm btn-light border-0 text-secondary p-1"
                                                @click="openEditAttendance(att)" title="Editar">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                            <button class="btn btn-sm btn-light border-0 text-danger p-1"
                                                @click="confirmDeleteAttendance(att.id)" title="Excluir"><i
                                                    class="bi bi-trash"></i></button>
                                        </div>
                                    </div>

                                    <div class="small text-muted mb-2">
                                        <strong>Motivo:</strong> {{ att.reason?.title || 'Não especificado' }}
                                    </div>

                                    <p class="small text-secondary mb-3 bg-light p-2 rounded-2 text-break"
                                        style="white-space: pre-wrap; max-height: 80px; overflow-y: auto;">
                                        {{ att.description || 'Sem descrição informada.' }}
                                    </p>

                                    <div class="d-flex gap-2 mt-auto">
                                        <button class="btn btn-sm btn-pmg-primary flex-grow-1 py-2 fw-bold"
                                            @click="openLeadCrmModalFromTask(att.lead)">
                                            <i class="bi bi-headset me-1"></i> Abrir Atendimento
                                        </button>
                                        <button v-if="getLeadPhone(att.lead)"
                                            class="btn btn-sm btn-success text-white py-2 px-3"
                                            @click="openWhatsApp(att.lead)" title="Chamar no WhatsApp">
                                            <i class="bi bi-whatsapp fs-6"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else class="text-center py-5 bg-white rounded-3 border border-dashed">
                            <i class="bi bi-check-circle-fill fs-1 text-success opacity-75 mb-3 d-block"></i>
                            <h6 class="fw-bold text-dark">Tudo em dia!</h6>
                            <p class="text-muted small mb-0">Não há retornos pendentes ou atrasados para hoje.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ================= MODAL: MAPA DE CALOR (CIDADES) ================= -->
    <div class="modal fade" id="modalHeatmap" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" style="max-width: 95vw;">
            <div class="modal-content border-0 shadow-lg rounded-4" style="height: 90vh;">
                
                <div class="modal-header border-0 pt-4 px-4 pb-2 flex-shrink-0">
                    <h5 class="fw-bold m-0 text-dark">
                        <i class="bi bi-geo-alt-fill text-danger me-2"></i> Mapa de Calor Geográfico
                    </h5>
                    <button type="button" class="btn-close" @click="closeHeatmapModal"></button>
                </div>

                <div class="modal-body p-4 bg-light rounded-bottom-4 d-flex flex-column" style="height: calc(90vh - 80px);">
                    
                    <!-- PAINEL DE CONTROLES DO MAPA (Protegido com position e z-index alto) -->
                    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 p-3 bg-white rounded-3 border shadow-sm flex-shrink-0" style="position: relative; z-index: 1050;">
                        <div class="d-flex gap-4">
                            <!-- Toggle Labels -->
                            <div class="form-check form-switch d-flex align-items-center gap-2 m-0 p-0">
                                <input class="form-check-input m-0" type="checkbox" v-model="showMapLabels" id="toggleLabels" style="cursor: pointer; width: 2.5em; height: 1.25em;">
                                <label class="form-check-label fw-bold small text-secondary m-0" for="toggleLabels" style="cursor: pointer;">
                                    Exibir Nomes das Cidades
                                </label>
                            </div>
                            
                            <!-- Toggle Satélite -->
                            <div class="form-check form-switch d-flex align-items-center gap-2 m-0 p-0">
                                <input class="form-check-input m-0" type="checkbox" v-model="mapLayerType" id="toggleLayer" true-value="satellite" false-value="street" @change="switchMapLayer" style="cursor: pointer; width: 2.5em; height: 1.25em;">
                                <label class="form-check-label fw-bold small text-secondary m-0" for="toggleLayer" style="cursor: pointer;">
                                    Visão Satélite
                                </label>
                            </div>
                        </div>

                        <!-- Botão Exportar -->
                        <button class="btn btn-pmg-primary btn-sm px-3 shadow-sm" @click="exportMapImage" :disabled="loadingMapExport">
                            <span v-if="loadingMapExport" class="spinner-border spinner-border-sm me-1"></span>
                            <i v-else class="bi bi-download me-1"></i> Exportar Imagem (PNG)
                        </button>
                    </div>

                    <!-- WRAPPER PROTETOR (A classe dinâmica fica aqui, protegendo o Leaflet de quebras) -->
                    <div :class="{ 'hide-map-labels': !showMapLabels }" style="flex-grow: 1; display: flex; flex-direction: column; position: relative; z-index: 1;">
                        
                        <!-- MAPA EM SI (Intocável pelo Vue) -->
                        <div id="mapHeatmap" style="flex-grow: 1; width: 100%; border-radius: 12px; min-height: 400px;"></div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <!-- ================= MODAL: CALENDÁRIO CUSTOMIZADO (DIA, SEMANA, MÊS, ANO) ================= -->
<div class="modal fade" id="modalCalendar" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
        <div class="modal-content bg-light">
            <!-- Cabeçalho do Calendário -->
            <div class="modal-header border-0 pt-4 px-4 pb-3 bg-white shadow-sm" style="z-index: 10;">
                <div class="d-flex align-items-center justify-content-between w-100">
                    
                    <!-- Navegação (Hoje, Views, Setas) -->
                    <div class="d-flex align-items-center gap-3">
                        <button class="btn btn-pmg-light btn-sm fw-bold px-3" @click="goToTodayCal">Hoje</button>
                        
                        <select v-model="currentCalView" class="form-select form-control-pmg form-select-sm w-auto fw-medium bg-light border-0 shadow-sm cursor-pointer">
                            <option value="day">Visualizar Dia</option>
                            <option value="week">Visualizar Semana</option>
                            <option value="month">Visualizar Mês</option>
                            <option value="year">Visualizar Ano</option>
                        </select>

                        <div class="btn-group shadow-sm">
                            <button class="btn btn-light border" @click="navigateCal(-1)"><i class="bi bi-chevron-left"></i></button>
                            <button class="btn btn-light border" @click="navigateCal(1)"><i class="bi bi-chevron-right"></i></button>
                        </div>
                        <h4 class="fw-bold m-0 text-dark ms-2 text-capitalize">{{ displayCalTitle }}</h4>
                    </div>
                    
                    <!-- Filtros e Fechar -->
                    <div class="d-flex align-items-center gap-4">
                        <div class="btn-group shadow-sm" role="group">
                            <input type="radio" class="btn-check" name="calFilter" id="calAll" value="all" v-model="calendarFilter">
                            <label class="btn btn-outline-secondary fw-bold btn-sm px-3" for="calAll">Todos</label>

                            <input type="radio" class="btn-check" name="calFilter" id="calAtt" value="attendance" v-model="calendarFilter">
                            <label class="btn btn-outline-warning fw-bold btn-sm px-3" for="calAtt">Atendimentos</label>

                            <input type="radio" class="btn-check" name="calFilter" id="calProd" value="product" v-model="calendarFilter">
                            <label class="btn btn-outline-info fw-bold btn-sm px-3 text-dark" for="calProd">Vínculos</label>
                        </div>
                        <button type="button" class="btn-close" @click="closeCalendarModal"></button>
                    </div>
                </div>
            </div>
            
            <!-- Corpo do Calendário -->
            <div class="modal-body p-4 d-flex flex-column">
                <div class="card border-0 shadow-sm flex-grow-1 bg-white rounded-4 overflow-hidden d-flex flex-column">
                    
                    <!-- VISUALIZAÇÃO: DIA -->
                    <div v-if="currentCalView === 'day'" class="day-view-container border-top flex-grow-1 h-100">
                        <div class="timeline-scroll h-100" ref="timelineContainer">
                            <div v-for="hour in 24" :key="'hour-'+(hour - 1)" class="hour-row d-flex border-bottom" :id="'hour-row-' + (hour - 1)">
                                <div class="hour-label text-muted small fw-bold p-3 border-end text-end" style="width: 80px; background: #f8fafc;">
                                    {{ String(hour - 1).padStart(2, '0') }}:00
                                </div>
                                <div class="hour-content flex-grow-1 p-2 position-relative transition-hover-bg" style="min-height: 70px; background: #fff;">
                                    
                                    <div v-for="event in getCalEventsForHour(currentCalendarDate, hour - 1)" :key="event.id" 
                                         class="event-card-day p-2 rounded-3 mb-1 shadow-sm border-start border-4 cursor-pointer"
                                         :class="event.type === 'attendance' ? 'bg-warning-subtle border-warning text-dark' : 'bg-info-subtle border-info text-dark'"
                                         @click.stop="handleCalendarEventClick(event)">
                                        <div class="fw-bold small text-truncate">
                                            <i :class="event.type === 'attendance' ? 'bi-headset' : 'bi-box-seam'" class="me-1"></i> {{ event.title }}
                                        </div>
                                        <div class="fs-8 opacity-75">{{ event.time ? event.time : 'Horário não definido' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- VISUALIZAÇÃO: SEMANA -->
                    <div v-else-if="currentCalView === 'week'" class="calendar-wrapper week-view d-flex border-top h-100">
                        <div v-for="dayObj in currentCalWeekDays" :key="dayObj.dateString" class="flex-fill border-end week-column">
                            <div class="text-center py-3 border-bottom bg-light cursor-pointer transition-hover" @click="goToSpecificDayCal(dayObj.date)">
                                <div class="small fw-bold text-muted text-uppercase mb-1">{{ dayObj.weekDayName }}</div>
                                <div class="fs-4 fw-bold" :class="dayObj.isToday ? 'text-primary' : 'text-dark'">
                                    <span :class="{'bg-primary text-white rounded-circle d-inline-block shadow-sm' : dayObj.isToday}" style="width: 40px; height: 40px; line-height: 40px;">
                                        {{ dayObj.dayNumber }}
                                    </span>
                                </div>
                            </div>
                            <div class="p-2 overflow-auto" style="height: calc(100vh - 280px);">
                                <div v-for="event in dayObj.events" :key="event.id" 
                                     class="event-badge text-truncate small mb-2 p-2 rounded-3 shadow-sm border-start border-4 cursor-pointer transition-hover-bg"
                                     :class="event.type === 'attendance' ? 'bg-warning-subtle border-warning' : 'bg-info-subtle border-info'"
                                     style="white-space: normal;"
                                     @click="handleCalendarEventClick(event)">
                                    <div class="fw-bold mb-1">
                                        <i :class="event.type === 'attendance' ? 'bi-headset' : 'bi-box-seam'" class="me-1"></i> {{ event.title }}
                                    </div>
                                    <div class="fs-7 opacity-75" v-if="event.time"><i class="bi bi-clock me-1"></i>{{ event.time }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- VISUALIZAÇÃO: MÊS -->
                    <div v-else-if="currentCalView === 'month'" class="calendar-wrapper flex-grow-1 d-flex flex-column">
                       <div class="calendar-grid-header bg-light border-top border-bottom">
                            <div v-for="day in weekDays" :key="day" class="text-center py-2 small fw-bold text-muted border-end">
                                {{ day }}
                            </div>
                        </div>

                        <div class="calendar-grid flex-grow-1 h-100">
                            <div v-for="blank in blankCalDays" :key="'blank-'+blank" class="calendar-day empty-day bg-light opacity-25"></div>
                            
                            <div v-for="date in daysInCalMonth" :key="'day-'+date" 
                                 class="calendar-day" 
                                 :class="{'today-cell bg-primary-subtle bg-opacity-10': isTodayCal(date, currentCalendarDate.getMonth(), currentCalendarDate.getFullYear())}" 
                                 @click="goToSpecificDayCal(new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth(), date))">
                                
                                <div class="day-header d-flex justify-content-between mb-1">
                                    <span class="day-number" :class="{'bg-primary text-white shadow-sm': isTodayCal(date, currentCalendarDate.getMonth(), currentCalendarDate.getFullYear())}">
                                        {{ date }}
                                    </span>
                                </div>

                                <div class="event-list-scroll">
                                    <div v-for="event in getCalEventsForDate(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth(), date)" 
                                         :key="event.id" 
                                         class="event-badge-mini cursor-pointer shadow-sm text-dark" 
                                         :class="event.type === 'attendance' ? 'bg-warning border-warning' : 'bg-info border-info'"
                                         @click.stop="handleCalendarEventClick(event)">
                                        <span class="fw-bold me-1" v-if="event.time">{{ event.time }}</span>
                                        <span class="event-title-text">{{ event.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- VISUALIZAÇÃO: ANO -->
                    <div v-else-if="currentCalView === 'year'" class="year-view p-4 border-top overflow-auto h-100">
                        <div class="row g-4">
                            <div v-for="(monthName, index) in monthsNames" :key="index" class="col-md-4 col-lg-3">
                                <div class="card h-100 border-0 shadow-sm rounded-4 cursor-pointer transition-hover" @click="goToMonthCal(index)">
                                    <div class="card-header bg-transparent border-bottom-0 pt-3 pb-0 text-center">
                                        <h6 class="fw-bold text-dark text-uppercase mb-0">{{ monthName }}</h6>
                                    </div>
                                    <div class="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                        <span class="fs-1 fw-light text-muted opacity-25 mb-2">{{ index + 1 }}</span>
                                        <div class="badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mt-2 border border-primary-subtle shadow-sm">
                                            {{ getCalEventsCountForMonth(index) }} Retornos
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import api from '@/services/api';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.heat';

export default {
    inject: ['globalLoading'],
    data() {
        return {
            pageId: this.$route.params.id,
            pageInfo: null,
            leads: [],
            alerts: [],
            selectedIds: [],
            filter: {
                search: '',
                start_date: '',
                end_date: '',
                status: '',
                productable_ids: '',
                item_status: '',
                item_start_date: '',
                item_end_date: '',
                date_precision: 'full',
                contacted_start_date: '',
                contacted_end_date: '',
                item_return_start_date: '',
                item_return_end_date: '',
                attendance_return_start_date: '',
                attendance_return_end_date: '',
                return_start_date: '',
                return_end_date: '',  
            },

            filterProductType: 'App\\Models\\Product',
            filterProductQuery: '',
            filterProductResults: [],
            showFilterProductDrop: false,
            filterProductDebounce: null,
            selectedFilterProduct: null,
            currentView: localStorage.getItem('lead_view_mode') || 'kanban',
            selectedLead: null,

            kanbanColumns: [
                { id: 'nao_abordado', title: 'Não Abordado', cardClass: 'bg-secondary-subtle border-secondary' },
                { id: 'contato_efetuado', title: 'Contato Efetuado', cardClass: 'bg-info-subtle border-info' },
                { id: 'proposta_enviada', title: 'Proposta Enviada', cardClass: 'bg-primary-subtle border-primary' },
                { id: 'lead_quente', title: 'Lead Quente', cardClass: 'bg-warning-subtle border-warning' },
                { id: 'fechamento', title: 'Fechamento', cardClass: 'bg-success-subtle border-success' }
            ],

            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            hasMore: false,

            showFilter: false,
            itemToDelete: null,
            isBulkDelete: false,

            exportFormat: 'pdf',
            loadingReport: false,
            reportModalInstance: null,
            reportFilters: {
                start_date: '',
                end_date: '',
                status: '',
                productable_ids: '',
                item_status: '',
                item_start_date: '',
                item_end_date: '',
                contacted_start_date: '',
                contacted_end_date: '',
                item_return_start_date: '',
                item_return_end_date: '',
                fields: [],
                report_type: 'resumido',
                include_products: true,
                include_attendances: true,
                include_notes: true,
                date_precision: 'full',
                chart_type: 'pie',
                return_start_date: '',
                return_end_date: '',  

            },

            // DADOS AUXILIARES PARA O MODAL CRM
            modalCrmInstance: null,
            reasonsList: [],
            loadingCrmSave: false,

            // Variáveis do Histórico Interno e Abas
            activeTab: 'details',
            content: '',
            loadingNote: false,

            crmForm: {
                id: null,
                reason_id: '',
                new_reason: '',
                productable_type: '',
                productable_id: '',
                initial_description: '',
                contacted_at: '',
                status: ''
            },

            productSearchQuery: '',
            productSearchResults: [],
            showProductDropdown: false,
            productDebounce: null,

            // DADOS DA AUDITORIA
            modalAuditInstance: null,
            selectedLeadAudit: null,
            auditLogs: [],
            modalFunnelInstance: null,
            attendanceViewMode: 'list', // 'list' ou 'form'
            leadAttendances: [],
            loadingAttendanceSave: false,

            attendanceForm: {
                id: null,
                reason_id: '',
                new_reason: '',
                contacted_at: '',
                next_contact_at: '',
                description: '',
                is_open: true
            },
            attendanceToDeleteId: null,
            localProductables: [],
            loadingSyncProductables: false,
            linkType: 'App\\Models\\Product',
            linkQuery: '',
            linkResults: [],
            showLinkDrop: false,
            linkDebounce: null,
            reportProductType: 'App\\Models\\Product',
            reportProductQuery: '',
            reportProductResults: [],
            showReportProductDrop: false,
            reportProductDebounce: null,
            selectedReportProduct: null,
            modalFollowUpsInstance: null,
            todayFollowUps: [],
            modalHeatmapInstance: null,
            heatmapData: [],
            allLeadsMetrics: [],
            loadingMetrics: false,
            mapInstance: null,
            showMapLabels: true,
            mapLayerType: 'street', // 'street' ou 'satellite'
            streetLayer: null,
            satelliteLayer: null,
            loadingMapExport: false,
            return_start_date: '',
            return_end_date: '',  
            isEditingResponses: false,
            editableResponses: {},
            loadingSaveResponses: false,
            modalCalendarInstance: null,
            calendarFilter: 'all',
            allCalendarEvents: [],
            currentCalendarDate: new Date(),
            currentCalView: 'month',
            monthsNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'], 
            weekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'], 
        }
    },
    computed: {
        isAllSelected() {
            return this.leads.length > 0 && this.selectedIds.length === this.leads.length;
        },
        isReportValid() {
            return this.reportFilters.fields.length > 0;
        },
        isCrmFormValid() {
            if (this.crmForm.reason_id === 'NEW') {
                return this.crmForm.new_reason.trim() !== '';
            }
            return true;
        },
        groupedLeads() {
            const groups = {};
            this.kanbanColumns.forEach(col => { groups[col.id] = []; });
            this.leads.forEach(lead => {
                if (groups[lead.status]) groups[lead.status].push(lead);
            });
            return groups;
        },
        // Computed para filtrar apenas as atividades que são "notas" manuais
        leadNotes() {
            if (!this.selectedLead || !this.selectedLead.notes) return [];
            return this.selectedLead.notes;
        },
        funnelData() {
            if (!this.kanbanColumns || !this.allLeadsMetrics) return [];

            const total = this.allLeadsMetrics.length;

            return this.kanbanColumns.map((col) => {
                const count = this.allLeadsMetrics.filter(l => l.status === col.id).length;
                const overallRate = total === 0 ? 0 : Math.round((count / total) * 100);

                return {
                    ...col,
                    count: count,
                    overallRate,
                    conversionRate: 0
                };
            });
        },
        linkedProducts() {
            return this.localProductables.filter(p => p.productable_type === 'App\\Models\\Product');
        },
        linkedServices() {
            return this.localProductables.filter(p => p.productable_type === 'App\\Models\\Service');
        },
        displayCalTitle() {
            const year = this.currentCalendarDate.getFullYear();
            const month = this.currentCalendarDate.getMonth();
            const date = this.currentCalendarDate.getDate();

            if (this.currentCalView === 'year') return `${year}`;
            if (this.currentCalView === 'month') return `${this.monthsNames[month]} ${year}`;
            if (this.currentCalView === 'day') return `${date} de ${this.monthsNames[month]} de ${year}`;
            
            if (this.currentCalView === 'week') {
                const firstDay = new Date(this.currentCalendarDate);
                firstDay.setDate(date - this.currentCalendarDate.getDay());
                const lastDay = new Date(firstDay);
                lastDay.setDate(firstDay.getDate() + 6);
                return `${firstDay.getDate()} ${this.monthsNames[firstDay.getMonth()]} - ${lastDay.getDate()} ${this.monthsNames[lastDay.getMonth()]} de ${year}`;
            }
            return '';
        },
        daysInCalMonth() {
            return new Date(this.currentCalendarDate.getFullYear(), this.currentCalendarDate.getMonth() + 1, 0).getDate();
        },
        blankCalDays() {
            return new Date(this.currentCalendarDate.getFullYear(), this.currentCalendarDate.getMonth(), 1).getDay();
        },
        currentCalWeekDays() {
            const days = [];
            const startOfWeek = new Date(this.currentCalendarDate);
            startOfWeek.setDate(this.currentCalendarDate.getDate() - this.currentCalendarDate.getDay());
            
            for (let i = 0; i < 7; i++) {
                const dayDate = new Date(startOfWeek);
                dayDate.setDate(startOfWeek.getDate() + i);
                days.push({
                    date: dayDate,
                    dateString: this.formatDateObjToString(dayDate),
                    dayNumber: dayDate.getDate(),
                    weekDayName: this.weekDays[i],
                    isToday: this.isTodayCal(dayDate.getDate(), dayDate.getMonth(), dayDate.getFullYear()),
                    events: this.getCalEventsForDate(dayDate.getFullYear(), dayDate.getMonth(), dayDate.getDate())
                });
            }
            return days;
        },
        filteredCalEvents() {
            return this.allCalendarEvents.filter(e => {
                return this.calendarFilter === 'all' || e.type === this.calendarFilter;
            });
        }

    },
    watch: {
        currentView(newValue) {
            localStorage.setItem('lead_view_mode', newValue);
        },
        currentCalView() {
            this.scrollToCurrentCalTime();
        },
        currentCalendarDate() {
            this.scrollToCurrentCalTime();
        }
    },
    mounted() {
        this.$nextTick(() => {
            const reportEl = document.getElementById('modalGeneralReport');
            if (reportEl) this.reportModalInstance = new window.bootstrap.Modal(reportEl);

            const crmEl = document.getElementById('modalLeadCrm');
            if (crmEl) this.modalCrmInstance = new window.bootstrap.Modal(crmEl);

            const auditEl = document.getElementById('modalAuditTimeline');
            if (auditEl) this.modalAuditInstance = new window.bootstrap.Modal(auditEl);

            const funnelEl = document.getElementById('modalFunnel');
            if (funnelEl) this.modalFunnelInstance = new window.bootstrap.Modal(funnelEl);

            const followUpsEl = document.getElementById('modalFollowUps');
            if (followUpsEl) this.modalFollowUpsInstance = new window.bootstrap.Modal(followUpsEl);

            const heatmapEl = document.getElementById('modalHeatmap');
            if (heatmapEl) this.modalHeatmapInstance = new window.bootstrap.Modal(heatmapEl);

        });

        this.fetchLeads();
        this.fetchAuxiliaryData();
        this.fetchTodayFollowUps();

    },
    methods: {
        async fetchLeads(page = 1, append = false) {
            this.loading = true;
            try {
                this.globalLoading.show('Carregando leads...');
                const params = { page: page, ...this.filter };
                const response = await api.get(`/capture-pages/${this.pageId}/leads`, { params });
                const payload = response.data;

                if (!this.pageInfo && payload.page) {
                    this.pageInfo = payload.page;
                    this.reportFilters.fields = this.pageInfo.fields.map(f => f.id);
                }

                const leadsData = payload.data?.data || payload.data || [];
                const normalizeStatus = (dbStatus) => {
                    const statusMap = {
                        'Não Abordado': 'nao_abordado',
                        'Contato Efetuado': 'contato_efetuado',
                        'Proposta Enviada': 'proposta_enviada',
                        'Lead Quente': 'lead_quente',
                        'Fechamento': 'fechamento'
                    };
                    return statusMap[dbStatus] || dbStatus || 'nao_abordado';
                };

                const formattedLeads = leadsData.map(lead => ({
                    ...lead,
                    status: normalizeStatus(lead.status),
                    notes: lead.notes || [],
                    attendances: lead.attendances || [],
                    products_and_services: lead.products_and_services || []
                }));

                if (append) {
                    this.leads = [...this.leads, ...formattedLeads];
                } else {
                    this.leads = formattedLeads;
                }

                const paginationData = payload.data || payload;
                this.currentPage = paginationData.current_page || 1;
                this.lastPage = paginationData.last_page || 1;
                this.totalItems = paginationData.total || this.leads.length;
                this.hasMore = this.currentPage < this.lastPage;

            } catch (error) {
                this.showAlert('Falha ao buscar leads.', 'error');
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        async fetchAuxiliaryData() {
            try {
                const resReasons = await api.get('/lead-reasons');
                this.reasonsList = resReasons.data.data || resReasons.data;
            } catch (e) {
                console.error("Erro ao carregar motivos", e);
            }
        },

        // --- MANIPULAÇÃO DA AUDITORIA ---
        openAuditModal(lead) {
            this.selectedLeadAudit = lead;
            // Filtra para mostrar apenas logs automáticos (created, updated, deleted) na trilha de auditoria
            this.auditLogs = (lead.activities || []).filter(a => a.action !== 'note');
            this.modalAuditInstance.show();
        },

        closeAuditModal() {
            this.modalAuditInstance.hide();
            this.selectedLeadAudit = null;
            this.auditLogs = [];
        },

        translateField(field) {
            const dictionary = {
                'status': 'Status',
                'user_id': 'Atendente Vinculado',
                'reason_id': 'Motivo / Assunto',
                'productable_id': 'Produto/Serviço (ID)',
                'productable_type': 'Tipo de Vínculo',
                'initial_description': 'Descrição Inicial',
                'contacted_at': 'Data de Contato',
                'description': 'Descrição',
                'content': 'Descrição'
            };
            return dictionary[field] || field;
        },

        formatValue(field, value) {
            if (value === null || value === undefined || value === '') {
                return 'N/A';
            }
            if (field === 'status') {
                return this.getStatusName(value);
            }
            return value;
        },

        openLeadCrmModal(lead) {
            this.selectedLead = lead;
            this.activeTab = 'responses';
            this.isEditingResponses = false;
            this.content = '';
            this.attendanceViewMode = 'list';
            this.leadAttendances = lead.attendances || [];
            this.localProductables = lead.products_and_services
                ? JSON.parse(JSON.stringify(lead.products_and_services)).map(item => {
                    item.start_date = this.formatDateForInput(item.start_date);
                    item.end_date = this.formatDateForInput(item.end_date);
                    item.return_date = this.formatDateForInput(item.return_date);
                    item.status = item.status || 'nao_negociado';
                    item.observation = item.observation || '';
                    return item;
                })
                : [];

            this.auditLogs = (lead.activities || []).filter(a => a.action !== 'note');
            this.crmForm = {
                id: lead.id,
                reason_id: lead.reason_id || lead.reason?.id || '',
                new_reason: '',
                productable_type: lead.productable_type || '',
                productable_id: lead.productable_id || '',
                initial_description: lead.initial_description || '',
                contacted_at: this.formatDateTimeLocal(lead.contacted_at),
                status: lead.status
            };

            this.productSearchQuery = lead.productable?.name || lead.productable?.description || '';
            this.productSearchResults = [];

            this.modalCrmInstance.show();
        },

        async saveLeadCrm() {
            this.loadingCrmSave = true;
            try {
                const payload = { ...this.crmForm };

                if (payload.reason_id === 'NEW') {
                    payload.reason_id = null;
                } else {
                    delete payload.new_reason;
                }

                const response = await api.patch(`/leads/${this.crmForm.id}`, payload);
                const updatedLead = response.data.data;

                const index = this.leads.findIndex(l => l.id === updatedLead.id);
                if (index !== -1) {
                    this.leads[index] = { ...this.leads[index], ...updatedLead };
                }

                this.showAlert('Dados operacionais do Lead atualizados!');
                this.modalCrmInstance.hide();

                if (this.crmForm.reason_id === 'NEW') {
                    this.fetchAuxiliaryData();
                }
            } catch (e) {
                console.error("Erro ao atualizar CRM do Lead:", e);
                this.showAlert('Erro ao atualizar dados operacionais.', 'error');
            } finally {
                this.loadingCrmSave = false;
            }
        },

        async saveNote() {
            if (!this.crmForm.id) {
                this.showAlert('Lead não selecionado.', 'error');
                return;
            }

            this.loadingNote = true;
            try {
                const response = await api.post(`/leads/${this.crmForm.id}/notes`, {
                    content: this.content
                });

                const newNote = response.data?.note || response.data;

                if (newNote) {
                    // 1. Atualiza no array principal de leads
                    const index = this.leads.findIndex(l => l.id === this.crmForm.id);
                    if (index !== -1) {
                        if (!this.leads[index].notes) {
                            this.leads[index].notes = [];
                        }
                        this.leads[index].notes.unshift(newNote);
                    }

                }

                this.newNoteText = '';
                this.content = '';
                this.showAlert('Nota registrada com sucesso!');
            } catch (e) {
               if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar.", "error");
                }
            } finally {
                this.loadingNote = false;
            }
        },

        onProductableTypeChange() {
            this.productSearchQuery = '';
            this.crmForm.productable_id = '';
            this.productSearchResults = [];
        },

        onProductInput() {
            this.showProductDropdown = true;
            clearTimeout(this.productDebounce);

            if (!this.productSearchQuery || this.productSearchQuery.length < 2) {
                this.productSearchResults = [];
                return;
            }

            this.productDebounce = setTimeout(async () => {
                try {
                    const endpoint = this.crmForm.productable_type === 'App\\Models\\Product' ? '/products' : '/services';
                    const res = await api.get(endpoint, { params: { search: this.productSearchQuery, limit: 8 } });
                    this.productSearchResults = res.data.data || res.data;
                } catch (e) {
                    console.error("Erro ao buscar itens polimórficos", e);
                }
            }, 300);
        },

        selectProduct(item) {
            this.crmForm.productable_id = item.id;
            this.productSearchQuery = item.name ?? item.description ?? '';
            this.showProductDropdown = false;
        },

        hideProductDropdown() {
            setTimeout(() => {
                this.showProductDropdown = false;
            }, 200);
        },

        startDrag(evt, lead) {
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            evt.dataTransfer.setData('leadID', lead.id);
        },

        async onDrop(evt, newStatusId) {
            const leadID = evt.dataTransfer.getData('leadID');
            const index = this.leads.findIndex(l => l.id == leadID);

            if (index !== -1 && this.leads[index].status !== newStatusId) {
                const updatedLeads = [...this.leads];
                updatedLeads[index] = { ...updatedLeads[index], status: newStatusId };
                this.leads = updatedLeads;
                await this.updateLeadStatus(this.leads[index]);
            }
        },

        async changeStatusFromList(item, newStatusId) {
            if (item.status === newStatusId) return;
            document.body.click();
            item.status = newStatusId;
            await this.updateLeadStatus(item);
        },

        async updateLeadStatus(lead) {
            try {
                const response = await api.post(`/capture-pages/${lead.id}/status`, { status: lead.status });
                const updatedLead = response.data.data;

                const index = this.leads.findIndex(l => l.id === lead.id);
                if (index !== -1 && updatedLead) {
                    this.leads[index] = { ...this.leads[index], ...updatedLead };
                }
                this.showAlert('Lead atualizado.');
                this.fetchLeads(1, false);
            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao atualizar status.", "error");
                }
            }
        },

        refreshData() { this.fetchLeads(1, false); },
        loadMore() { if (this.hasMore && !this.loading) this.fetchLeads(this.currentPage + 1, true); },
        applyFilter() { this.showFilter = false; this.fetchLeads(1, false); },

        getResponseValue(lead, field) {
            const key = field.name || field.label;
            return lead.responses && lead.responses[key] ? lead.responses[key] : '-';
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
        },

        formatDateTimeLocal(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
        },

        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = type === 'error' ? 'bi-x-circle-fill' : 'bi-check-circle-fill';
            this.alerts.push({ id, message, type, icon });
            setTimeout(() => this.removeAlert(id), 8000);
        },

        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/leads/bulk-delete', { ids: this.selectedIds });
                    this.leads = this.leads.filter(c => !this.selectedIds.includes(c.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} leads excluídos.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/capture-pages/${this.itemToDelete.id}`);
                    this.leads = this.leads.filter(c => c.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    this.showAlert(`Lead removido com sucesso.`);
                }
            } catch (error) {
                this.showAlert('Erro ao excluir registro(s).', 'error');
            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) window.bootstrap.Modal.getInstance(modalElement)?.hide();
            }
        },

        toggleAll(e) {
            this.selectedIds = e.target.checked ? this.leads.map(c => c.id) : [];
        },

        openReportModal(format = 'pdf') {
            this.exportFormat = format;
            this.reportModalInstance?.show();
        },

        async generateReport(format = 'pdf') {
            this.loadingReport = true;
            try {
                const filtersToSend = { ...this.reportFilters };
                filtersToSend.fields = filtersToSend.fields.join(',');

                // O URLSearchParams vai transformar os nossos novos booleanos em strings "true"/"false" perfeitamente
                const params = new URLSearchParams(filtersToSend).toString();

                // Define configurações dinâmicas baseadas no formato escolhido
                const isPdf = format === 'pdf';
                const endpoint = isPdf ? 'pdf' : 'excel';
                const extension = isPdf ? 'pdf' : 'xlsx';
                const mimeType = isPdf
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                const response = await api.get(`/capture-pages/${this.pageId}/reports/${endpoint}?${params}`, { responseType: 'blob' });

                const blob = new Blob([response.data], { type: mimeType });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `relatorio_leads_${this.pageId}_${Date.now()}.${extension}`);
                document.body.appendChild(link);
                link.click();

                // Limpeza
                link.remove();
                window.URL.revokeObjectURL(url); // Libera a memória do navegador

                this.reportModalInstance.hide();
                this.showAlert(`Arquivo ${extension.toUpperCase()} gerado com sucesso!`);
            } catch (e) {
                console.error("Erro na exportação:", e);
                this.showAlert(`Erro ao exportar arquivo ${format.toUpperCase()}.`, "error");
            } finally {
                this.loadingReport = false;
            }
        },

        openLeadDetails(lead) {
            this.selectedLead = lead;
            const modalElement = document.getElementById('leadDetailsModal');
            if (modalElement) {
                const modal = new window.bootstrap.Modal(modalElement);
                modal.show();
            }
        },

        getStatusSelectClass(statusId) {
            const statusMap = {
                'nao_abordado': 'bg-secondary-subtle text-secondary border-secondary',
                'contato_efetuado': 'bg-info-subtle text-info-emphasis border-info',
                'proposta_enviada': 'bg-primary-subtle text-primary-emphasis border-primary',
                'lead_quente': 'bg-warning-subtle text-warning-emphasis border-warning',
                'fechamento': 'bg-success-subtle text-success-emphasis border-success'
            };
            return statusMap[statusId] || 'bg-light text-dark border-light';
        },

        getStatusName(statusId) {
            const status = this.kanbanColumns.find(col => col.id === statusId);
            return status ? status.title : 'Desconhecido';
        },

        getStatusBadgeClass(statusId) {
            const statusMap = {
                'nao_abordado': 'bg-secondary text-white',
                'contato_efetuado': 'bg-info text-white',
                'proposta_enviada': 'bg-primary text-white',
                'lead_quente': 'bg-warning text-dark',
                'fechamento': 'bg-success text-white'
            };
            return statusMap[statusId] || 'bg-light text-dark border';
        },

        getDotColor(statusId) {
            const colorMap = {
                'nao_abordado': 'bg-secondary',
                'contato_efetuado': 'bg-info',
                'proposta_enviada': 'bg-primary',
                'lead_quente': 'bg-warning',
                'fechamento': 'bg-success'
            };
            return colorMap[statusId] || 'bg-dark';
        },
        async openFunnelModal() {
            this.globalLoading.show('Calculando métricas...'); // Opcional: mostra o loader global
            await this.fetchMetricsData();
            this.globalLoading.hide();

            if (this.modalFunnelInstance) {
                this.modalFunnelInstance.show();
            }
        },

        closeFunnelModal() {
            if (this.modalFunnelInstance) {
                this.modalFunnelInstance.hide();
            }
        },
        getLeadPhone(lead) {
            if (!lead || !lead.responses) return null;
            // Varre as chaves do form procurando termos associados a telefone
            const phoneKeys = ['telefone', 'celular', 'whatsapp', 'phone', 'wpp', 'contato'];
            for (const [key, value] of Object.entries(lead.responses)) {
                if (phoneKeys.some(pk => key.toLowerCase().includes(pk))) {
                    if (value) {
                        // Limpa a formatação, deixando apenas números
                        const cleaned = String(value).replace(/\D/g, '');
                        if (cleaned.length >= 10) return cleaned; // Garante que tem ao menos DDD + Número
                    }
                }
            }
            return null;
        },

        openWhatsApp(lead) {
            const phone = this.getLeadPhone(lead);
            if (!phone) {
                this.showAlert('Nenhum número de telefone válido encontrado nas respostas deste lead.', 'error');
                return;
            }
            // Verifica se possui DDI do Brasil, se não, adiciona
            const formattedPhone = phone.startsWith('55') ? phone : `55${phone}`;
            const text = encodeURIComponent(`Olá! Recebemos seu contato através da nossa página de captura. Como podemos ajudar?`);
            window.open(`https://api.whatsapp.com/send?phone=${formattedPhone}&text=${text}`, '_blank');
        },

        getSlaStatus(lead) {
            // SLA só é contabilizado para leads na fila "Não Abordado"
            if (lead.status !== 'nao_abordado') return null;

            const created = new Date(lead.created_at).getTime();
            const now = new Date().getTime();
            const diffHours = (now - created) / (1000 * 60 * 60);

            if (diffHours >= 24) {
                return {
                    class: 'border-start border-4 border-danger bg-danger-subtle bg-opacity-10',
                    alert: true,
                    badgeClass: 'bg-danger text-white border-danger shadow',
                    icon: 'bi-exclamation-triangle',
                    text: '+24h sem contato'
                };
            } else if (diffHours >= 2) {
                return {
                    class: 'border-start border-4 border-warning bg-warning-subtle bg-opacity-10',
                    alert: true,
                    badgeClass: 'bg-warning text-dark border-warning shadow',
                    icon: 'bi-clock-history',
                    text: '+2h na fila'
                };
            }
            return null;
        },
        getLeadIdentifier(lead) {
            if (!this.pageInfo || !this.pageInfo.fields) return 'Lead sem identificador';

            // Procura o campo marcado com is_identifier
            const identifierField = this.pageInfo.fields.find(f => f.is_identifier);

            if (identifierField) {
                const key = identifierField.name || identifierField.label;
                if (lead.responses && lead.responses[key]) {
                    return lead.responses[key];
                }
            }
            return 'Lead #' + lead.id.substring(0, 8);
        },
        // Abre o formulário limpo para um NOVO atendimento
        openAddAttendance() {
            this.attendanceForm = {
                id: null,
                reason_id: '',
                contacted_at: this.formatDateTimeLocal(new Date()), // Preenche com a data/hora atual
                next_contact_at: '',
                description: '',
                is_open: true
            };
            this.attendanceViewMode = 'form';
        },

        // Abre o formulário preenchido para EDITAR um atendimento
        openEditAttendance(attendance) {
            this.attendanceForm = {
                id: attendance.id,
                reason_id: attendance.reason_id || '',
                contacted_at: this.formatDateTimeLocal(attendance.contacted_at),
                next_contact_at: this.formatDateTimeLocal(attendance.next_contact_at),
                description: attendance.description || '',
                is_open: attendance.is_open === undefined ? true : !!attendance.is_open
            };
            this.attendanceViewMode = 'form';
        },

        // Salva (Cria ou Atualiza) o atendimento na API
        async saveAttendance() {
            this.loadingAttendanceSave = true;
            try {
                const payload = { ...this.attendanceForm };
                if (payload.reason_id === 'NEW') {
                    payload.reason_id = null;
                } else {
                    delete payload.new_reason;
                }

                let response;
                if (payload.id) {
                    // Edição
                    response = await api.put(`/attendances/${payload.id}`, payload);
                    const updatedAtt = response.data.data;
                    const index = this.leadAttendances.findIndex(a => a.id === updatedAtt.id);
                    if (index !== -1) this.leadAttendances[index] = updatedAtt;
                    this.showAlert('Atendimento atualizado com sucesso!');
                } else {
                    // Criação (Vinculado ao Lead atual)
                    response = await api.post(`/leads/${this.selectedLead.id}/attendances`, payload);
                    const newAtt = response.data.data;
                    this.leadAttendances.unshift(newAtt); // Adiciona no topo da lista
                    this.showAlert('Novo atendimento registrado!');
                }

                if (this.attendanceForm.reason_id === 'NEW') {
                    this.fetchAuxiliaryData();
                }

                // Atualiza o array principal de leads para refletir no Kanban/Lista
                const leadIndex = this.leads.findIndex(l => l.id === this.selectedLead.id);
                if (leadIndex !== -1) {
                    this.leads[leadIndex].attendances = [...this.leadAttendances];

                    // Se precisar atualizar o status no Kanban após o atendimento, pode fazer aqui
                    // this.leads[leadIndex].status = 'contato_efetuado';
                }

                // Volta para a listagem
                this.attendanceViewMode = 'list';
            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar atendimento.", "error");
                }
            } finally {
                this.loadingAttendanceSave = false;
            }
        },

        // Exclui um atendimento
        async deleteAttendance(id) {
            if (!confirm('Deseja realmente excluir este registro de atendimento?')) return;

            try {
                await api.delete(`/attendances/${id}`);
                this.leadAttendances = this.leadAttendances.filter(a => a.id !== id);
                this.showAlert('Atendimento excluído.');
            } catch (error) {
                this.showAlert('Erro ao excluir atendimento.', 'error');
            }
        },

        confirmDeleteAttendance(id) {
            this.attendanceToDeleteId = id;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteAttendanceModal'));
            modal.show();
        },

        // Executa a exclusão de fato após a confirmação
        async executeAttendanceDeletion() {
            if (!this.attendanceToDeleteId) return;

            try {
                await api.delete(`/attendances/${this.attendanceToDeleteId}`);

                // Remove visualmente da lista de atendimentos
                this.leadAttendances = this.leadAttendances.filter(a => a.id !== this.attendanceToDeleteId);

                // Atualiza também no array principal de leads para refletir no Kanban/Lista
                const leadIndex = this.leads.findIndex(l => l.id === this.selectedLead.id);
                if (leadIndex !== -1) {
                    this.leads[leadIndex].attendances = [...this.leadAttendances];
                }

                this.showAlert('Atendimento excluído com sucesso.', 'danger');
            } catch (error) {
                this.showAlert('Erro ao excluir atendimento.', 'error');
            } finally {
                // Fecha o modal e limpa o ID
                const modalElement = document.getElementById('confirmDeleteAttendanceModal');
                if (modalElement) {
                    window.bootstrap.Modal.getInstance(modalElement)?.hide();
                }
                this.attendanceToDeleteId = null;
            }
        },

        onLinkTypeChange() {
            this.linkQuery = '';
            this.linkResults = [];
        },

        onLinkInput() {
            this.showLinkDrop = true;
            clearTimeout(this.linkDebounce);

            if (!this.linkQuery || this.linkQuery.length < 2) {
                this.linkResults = [];
                return;
            }

            this.linkDebounce = setTimeout(async () => {
                try {
                    const endpoint = this.linkType === 'App\\Models\\Product' ? '/products' : '/services';
                    const res = await api.get(endpoint, { params: { search: this.linkQuery, limit: 8 } });
                    this.linkResults = res.data.data || res.data;
                } catch (e) {
                    console.error("Erro ao buscar vínculos", e);
                }
            }, 300);
        },

        hideLinkDrop() {
            setTimeout(() => { this.showLinkDrop = false; }, 200);
        },

        selectLinkItem(item) {
            // Verifica se já não existe na lista
            const exists = this.localProductables.some(p => p.productable_id === item.id);
            if (exists) {
                this.showAlert('Este item já está vinculado ao lead.', 'warning');
            } else {
                this.localProductables.push({
                    id: null,
                    productable_type: this.linkType,
                    productable_id: item.id,
                    productable: item,
                    start_date: '',
                    end_date: '',
                    return_date: '',
                    status: 'nao_negociado',
                    observation: ''
                });
            }
            this.linkQuery = '';
            this.showLinkDrop = false;
        },

        removeLinkItem(itemToRemove) {
            this.localProductables = this.localProductables.filter(item => item !== itemToRemove);
        },

        async syncProductables() {
            this.loadingSyncProductables = true;
            try {
                const payload = {
                    items: this.localProductables.map(p => ({
                        id: p.id,
                        productable_type: p.productable_type,
                        productable_id: p.productable_id,
                        // Enviamos null pro Laravel se estiver vazio
                        start_date: this.formatDateForInput(p.start_date) || null,
                        end_date: this.formatDateForInput(p.end_date) || null,
                        return_date: this.formatDateForInput(p.return_date) || null,
                        status: p.status || 'nao_negociado',
                        observation: p.observation || null
                    }))
                };

                const response = await api.post(`/leads/${this.selectedLead.id}/products-services`, payload);
                const updatedLead = response.data.data;

                // Recebemos e mapeamos de volta pra tela
                this.localProductables = (updatedLead.products_and_services || []).map(item => {
                    item.start_date = this.formatDateForInput(item.start_date);
                    item.end_date = this.formatDateForInput(item.end_date);
                    item.return_date = this.formatDateForInput(item.return_date);
                    item.status = item.status || 'nao_negociado';
                    return item;
                });

                const index = this.leads.findIndex(l => l.id === this.selectedLead.id);
                if (index !== -1) {
                    this.leads[index].products_and_services = [...this.localProductables];
                }

                this.showAlert('Lista de produtos e serviços sincronizada com sucesso!');
            } catch (e) {
               if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao sincronizar produtos e serviços.", "error");
                }
            } finally {
                this.loadingSyncProductables = false;
            }
        },
        getActionBadge(action) {
            const map = {
                'created': { text: 'Criação do Lead', class: 'bg-success-subtle text-success border border-success-subtle' },
                'updated': { text: 'Edição de Dados', class: 'bg-primary-subtle text-primary border border-primary-subtle' },
                'deleted': { text: 'Exclusão', class: 'bg-danger-subtle text-danger border border-danger-subtle' },

                // Novos eventos adjacentes
                'attendance_created': { text: 'Novo Atendimento', class: 'bg-info-subtle text-info-emphasis border border-info-subtle' },
                'attendance_updated': { text: 'Atendimento Editado', class: 'bg-warning-subtle text-warning-emphasis border border-warning-subtle' },
                'attendance_deleted': { text: 'Atendimento Excluído', class: 'bg-danger text-white shadow-sm' },

                'products_synced': { text: 'Vínculos Sincronizados', class: 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle' },
                'note_created': { text: 'Nota Interna', class: 'bg-dark-subtle text-dark border border-dark-subtle' }
            };

            return map[action] || { text: action, class: 'bg-light text-dark border' };
        },

        translateProductField(field) {
            const dict = {
                'start_date': 'Data Início',
                'end_date': 'Data Fim',
                'return_date': 'Data de Retorno',
                'is_sold': 'Status de Venda',
                'status': 'Status',
                'user_id': 'Atendente Vinculado',
                'reason_id': 'Motivo / Assunto',
                'productable_id': 'Produto/Serviço (ID)',
                'productable_type': 'Tipo de Vínculo',
                'initial_description': 'Descrição Inicial',
                'contacted_at': 'Data de Contato',
                'description': 'Descrição / Resumo',
                'next_contact_at': 'Próximo Contato (Retorno)',
                'reason': 'Motivo do Atendimento'
            };
            return dict[field] || field;
        },

        // ==========================================
        // LÓGICA DO AUTOCOMPLETE NO FILTRO AVANÇADO
        // ==========================================

        onFilterProductTypeChange() {
            this.clearFilterProduct(); // Limpa a busca caso o usuário troque de Produto para Serviço
        },

        onFilterProductInput() {
            this.showFilterProductDrop = true;
            clearTimeout(this.filterProductDebounce);

            if (!this.filterProductQuery || this.filterProductQuery.length < 2) {
                this.filterProductResults = [];
                return;
            }

            this.filterProductDebounce = setTimeout(async () => {
                try {
                    const endpoint = this.filterProductType === 'App\\Models\\Product' ? '/products' : '/services';
                    const res = await api.get(endpoint, { params: { search: this.filterProductQuery, limit: 8 } });
                    this.filterProductResults = res.data.data || res.data;
                } catch (e) {
                    console.error("Erro ao buscar autocomplete no filtro", e);
                }
            }, 300);
        },

        hideFilterProductDrop() {
            setTimeout(() => { this.showFilterProductDrop = false; }, 200);
        },

        selectFilterProduct(item) {
            this.selectedFilterProduct = item;
            this.filter.productable_ids = item.id; // Anexa o UUID direto no objeto do axios
            this.filterProductQuery = item.name ?? item.description; // Preenche o input visualmente
            this.showFilterProductDrop = false;
        },

        clearFilterProduct() {
            this.selectedFilterProduct = null;
            this.filter.productable_ids = '';
            this.filterProductQuery = '';
            this.filterProductResults = [];
        },

        clearAllFilters() {
            // SUBSTITUA O MÉTODO INTEIRO POR ESTE:
            this.filter = {
                search: '',
                start_date: '',
                end_date: '',
                status: '',
                productable_ids: '',
                item_status: '',
                item_start_date: '',
                item_end_date: '',
                date_precision: 'full',
                contacted_start_date: '',
                contacted_end_date: '',
                attendance_return_start_date: '',
                attendance_return_end_date: '',
                item_return_start_date: '',
                item_return_end_date: ''
            };
            this.clearFilterProduct();
            this.applyFilter();
        },

        // ==========================================
        // LÓGICA DO AUTOCOMPLETE NO MODAL DE RELATÓRIO
        // ==========================================
        onReportProductTypeChange() {
            this.clearReportProduct();
        },

        onReportProductInput() {
            this.showReportProductDrop = true;
            clearTimeout(this.reportProductDebounce);

            if (!this.reportProductQuery || this.reportProductQuery.length < 2) {
                this.reportProductResults = [];
                return;
            }

            this.reportProductDebounce = setTimeout(async () => {
                try {
                    const endpoint = this.reportProductType === 'App\\Models\\Product' ? '/products' : '/services';
                    const res = await api.get(endpoint, { params: { search: this.reportProductQuery, limit: 8 } });
                    this.reportProductResults = res.data.data || res.data;
                } catch (e) {
                    console.error("Erro ao buscar autocomplete pro relatório", e);
                }
            }, 300);
        },

        hideReportProductDrop() {
            setTimeout(() => { this.showReportProductDrop = false; }, 200);
        },

        selectReportProduct(item) {
            this.selectedReportProduct = item;
            this.reportFilters.productable_ids = item.id;
            this.reportProductQuery = item.name ?? item.description;
            this.showReportProductDrop = false;
        },

        clearReportProduct() {
            this.selectedReportProduct = null;
            this.reportFilters.productable_ids = '';
            this.reportProductQuery = '';
            this.reportProductResults = [];
        },
        async fetchTodayFollowUps() {
            try {
                const res = await api.get(`/capture-pages/${this.pageId}/follow-ups`);
                this.todayFollowUps = res.data.data || res.data;
            } catch (e) {
                console.error("Erro ao buscar tarefas do dia", e);
            }
        },
        openFollowUpsModal() {
            this.fetchTodayFollowUps();
            if (this.modalFollowUpsInstance) {
                this.modalFollowUpsInstance.show();
            }
        },
        openLeadCrmModalFromTask(lead) {
            // Fecha o modal de tarefas primeiro e abre o CRM do lead escolhido
            if (this.modalFollowUpsInstance) {
                this.modalFollowUpsInstance.hide();
            }
            this.openLeadCrmModal(lead);
        },
        formatDateShort(dateString) {
            if (!dateString) return '';
            return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
        },
        isOverdue(dateString) {
            if (!dateString) return false;
            // Retorna true se a data do agendamento for estritamente anterior a agora
            return new Date(dateString) < new Date();
        },
        getProductStatusColor(status) {
            const colors = {
                'nao_negociado': 'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle',
                'em_negociacao': 'bg-warning-subtle text-warning-emphasis border-warning-subtle',
                'fechado': 'bg-success-subtle text-success-emphasis border-success-subtle',
                'desistencia': 'bg-danger-subtle text-danger-emphasis border-danger-subtle'
            };
            return colors[status] || 'bg-light text-dark border-light';
        },

        formatDateForInput(dateStr) {
            if (!dateStr || dateStr === '0000-00-00' || String(dateStr).includes('null')) {
                return ''; // Input de data prefere string vazia para ficar em branco
            }

            let str = String(dateStr);

            // Se a API estiver retornando no formato BR (DD/MM/YYYY), inverte para YYYY-MM-DD
            if (str.includes('/')) {
                const parts = str.split('/');
                if (parts.length === 3 && parts[2].length === 4) {
                    return `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
            }

            // Se já for YYYY-MM-DD (ou formato ISO com T e Z), pega os 10 primeiros caracteres
            return str.substring(0, 10);
        },

        extractCityHeatmapData() {
            if (!this.pageInfo || !this.pageInfo.fields || this.leads.length === 0) return null;

            // 1. Localiza o campo que representa a cidade
            const cityField = this.pageInfo.fields.find(field => {
                const name = field.name ? field.name.toLowerCase() : '';
                const label = field.label ? field.label.toLowerCase() : '';
                return name.includes('cidade') || label.includes('cidade') || label.includes('município');
            });

            if (!cityField) return null; // Não encontrou campo de cidade na captura

            // 2. Define a chave de busca (igual ao seu getResponseValue)
            const fieldKey = cityField.name || cityField.label;
            const cityHeatData = {};

            // 3. Agrupa as respostas
            this.leads.forEach(lead => {
                const cityName = lead.responses && lead.responses[fieldKey]
                    ? lead.responses[fieldKey].trim().toUpperCase()
                    : null;

                if (cityName && cityName !== '-') {
                    cityHeatData[cityName] = (cityHeatData[cityName] || 0) + 1;
                }
            });

            // O resultado será um objeto com a densidade: { "SÃO PAULO": 45, "CRATO": 12, "FORTALEZA": 30 }
            return cityHeatData;
        },

        async openHeatmapModal() {
            this.globalLoading.show('Gerando mapa de calor...');
            await this.fetchMetricsData(); // Puxa todos os leads sem paginação
            this.globalLoading.hide();

            if (this.modalHeatmapInstance) {
                this.modalHeatmapInstance.show();

                // Dá um tempinho pro modal terminar de abrir e desenha o mapa
                setTimeout(() => {
                    if (this.mapInstance) {
                        this.mapInstance.invalidateSize();
                    } else {
                        this.initMap();
                    }
                }, 300);
            }
        },
        closeHeatmapModal() {
            if (this.modalHeatmapInstance) {
                this.modalHeatmapInstance.hide();
            }
        },

        generateHeatmapData() {
            if (!this.pageInfo || !this.pageInfo.fields || this.allLeadsMetrics.length === 0) {
                this.heatmapData = [];
                return;
            }

            // 1. Procura o campo de cidade
            const cityField = this.pageInfo.fields.find(field => {
                const name = field.name ? field.name.toLowerCase() : '';
                const label = field.label ? field.label.toLowerCase() : '';
                return name.includes('cidade') || label.includes('cidade') || label.includes('município');
            });

            if (!cityField) {
                this.heatmapData = [];
                return;
            }

            const fieldKey = cityField.name || cityField.label;
            const cityCounts = {};

            // 2. Agrupa as cidades
            this.allLeadsMetrics.forEach(lead => {
                let cityName = lead.responses && lead.responses[fieldKey] ? lead.responses[fieldKey].trim().toUpperCase() : null;
                if (cityName && cityName !== '-' && cityName !== '') {
                    cityCounts[cityName] = (cityCounts[cityName] || 0) + 1;
                }
            });

            // 3. Transforma em array e ordena do maior pro menor
            let sortedCities = Object.keys(cityCounts).map(city => {
                return { name: city, count: cityCounts[city] };
            }).sort((a, b) => b.count - a.count);

            const maxCount = sortedCities.length > 0 ? sortedCities[0].count : 1;

            // 4. Calcula a "Temperatura" (porcentagem e cor)
            this.heatmapData = sortedCities.map(city => {
                const percentage = (city.count / maxCount) * 100;

                let colorClass = 'bg-danger'; // Quente
                let colorName = 'danger';

                if (percentage <= 75 && percentage > 40) {
                    colorClass = 'bg-warning'; // Morno
                    colorName = 'warning';
                } else if (percentage <= 40 && percentage > 15) {
                    colorClass = 'bg-info'; // Fresco
                    colorName = 'info';
                } else if (percentage <= 15) {
                    colorClass = 'bg-secondary'; // Frio
                    colorName = 'secondary';
                }

                return {
                    ...city,
                    percentage: percentage,
                    colorClass: colorClass,
                    colorName: colorName
                };
            });
        },

        async fetchMetricsData() {
            this.loadingMetrics = true;
            try {
                // Passamos os filtros atuais + a flag para trazer TUDO
                const params = { ...this.filter, per_page: 'all' };
                const response = await api.get(`/capture-pages/${this.pageId}/leads`, { params });
                const payload = response.data;

                this.allLeadsMetrics = payload.data?.data || payload.data || [];
            } catch (error) {
                this.showAlert('Erro ao buscar dados para métricas.', 'error');
            } finally {
                this.loadingMetrics = false;
            }
        },

        async initMap() {
            if (this.mapInstance) {
                this.mapInstance.remove();
                this.mapInstance = null;
            }

            const map = L.map('mapHeatmap').setView([-14.2350, -51.9253], 4);
            this.mapInstance = map;

            // Define as camadas
            this.streetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap', maxZoom: 18
            });
            this.satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                attribution: '© Esri', maxZoom: 18
            });

            if (this.mapLayerType === 'satellite') {
                this.satelliteLayer.addTo(map);
            } else {
                this.streetLayer.addTo(map);
            }

            try {
                const params = { ...this.filter };
                const res = await api.get(`/capture-pages/${this.pageId}/heatmap`, { params });
                const cities = res.data.cities || [];

                if (cities.length === 0) {
                    this.showAlert('Nenhuma cidade encontrada para gerar o mapa.', 'warning');
                    return;
                }

                const maxCount = Math.max(...cities.map(c => c.count));
                
                // Cria uma "caixa virtual" para o Leaflet saber qual zoom dar no final
                const mapBounds = L.latLngBounds(); 

                for (const item of cities) {
                    try {
                        // O SEGREDO AQUI: O parâmetro &polygon_geojson=1 pede o desenho exato da fronteira da cidade
                        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(item.name)}, Brazil&limit=1&polygon_geojson=1`);
                        const data = await response.json();

                        if (data && data.length > 0) {
                            const place = data[0];
                            
                            // Calcula a cor opaca baseada na quantidade de leads
                            const intensity = item.count / maxCount;
                            const fillOpacity = 0.25 + (intensity * 0.6); // Varia de 0.25 (claro) a 0.85 (escuro)

                            let mapElement;

                            // 1. Tenta pintar o polígono (fronteira exata)
                            if (place.geojson) {
                                mapElement = L.geoJSON(place.geojson, {
                                    style: {
                                        color: '#561569',       // Borda externa do município
                                        weight: 2,              // Espessura da linha
                                        fillColor: '#9333ea',   // Cor do preenchimento
                                        fillOpacity: fillOpacity
                                    }
                                }).addTo(map);
                            } 
                            // 2. Fallback: Se for uma região muito remota sem fronteira mapeada, pinta uma bolinha pequena de 3km
                            else {
                                const lat = parseFloat(place.lat);
                                const lon = parseFloat(place.lon);
                                mapElement = L.circle([lat, lon], {
                                    color: '#561569',
                                    weight: 2,
                                    fillColor: '#9333ea',
                                    fillOpacity: fillOpacity,
                                    radius: 3000 // Trava em 3km para não vazar pra cidade vizinha
                                }).addTo(map);
                            }

                            // Vincula o nome da cidade permanentemente no centro do desenho
                            mapElement.bindTooltip(`<b>${item.name}</b> (${item.count})`, {
                                permanent: true,         
                                direction: 'center',     
                                className: 'city-badge-label' 
                            });

                            // Mantém o popup ao clicar
                            mapElement.bindPopup(`<b>${item.name}</b><br>🎯 Total: ${item.count} lead(s)`);

                            // Adiciona as medidas desse polígono na nossa caixa virtual de zoom
                            mapBounds.extend(mapElement.getBounds());
                        }

                        // Respeito ao limite de requisições da API
                        await new Promise(resolve => setTimeout(resolve, 1000));
                    } catch (err) {
                        console.error(`Erro ao buscar fronteiras para ${item.name}`, err);
                    }
                }

                // Aplica o zoom perfeito cobrindo exatamente as fronteiras desenhadas
                if (mapBounds.isValid()) {
                    map.fitBounds(mapBounds, { padding: [50, 50], maxZoom: 10 });
                }

            } catch (e) {
                console.error("Erro ao carregar mapa:", e);
                this.showAlert('Erro ao gerar o mapa geográfico.', 'error');
            }
        },

        // Alterna dinamicamente entre Satélite e Mapa de Ruas
        switchMapLayer() {
            if (!this.mapInstance) return;
            
            if (this.mapLayerType === 'satellite') {
                this.mapInstance.removeLayer(this.streetLayer);
                this.satelliteLayer.addTo(this.mapInstance);
            } else {
                this.mapInstance.removeLayer(this.satelliteLayer);
                this.streetLayer.addTo(this.mapInstance);
            }
        },

        // Exporta o mapa em imagem usando o html2canvas
        async exportMapImage() {
            this.loadingMapExport = true;
            try {
                const html2canvas = (await import('html2canvas')).default;
                const mapElement = document.getElementById('mapHeatmap');
                
                const canvas = await html2canvas(mapElement, {
                    useCORS: true, // Crucial para não dar erro ao ler os "tiles" do OpenStreetMap
                    allowTaint: false,
                    scale: 2, // Aumenta a resolução da imagem final
                    ignoreElements: (node) => {
                        // Ignora os botões de Zoom nativos do Leaflet na foto final
                        return node.classList && node.classList.contains('leaflet-control-container');
                    }
                });
                
                const link = document.createElement('a');
                link.download = `Mapa_Calor_RMR_${new Date().getTime()}.png`;
                link.href = canvas.toDataURL('image/png');
                link.click();
                link.remove();
                
                this.showAlert('Mapa exportado com sucesso!');
            } catch(e) {
                console.error("Erro na exportação do mapa:", e);
                this.showAlert('Erro ao exportar a imagem. Tente novamente.', 'error');
            } finally {
                this.loadingMapExport = false;
            }
        },

        startEditingResponses() {
            this.editableResponses = {};
            // Popula o objeto de edição com as respostas atuais baseadas nos campos mapeados
            if (this.pageInfo && this.pageInfo.fields) {
                this.pageInfo.fields.forEach(field => {
                    const key = field.name || field.label;
                    this.editableResponses[key] = this.selectedLead.responses && this.selectedLead.responses[key] ? this.selectedLead.responses[key] : '';
                });
            }
            this.isEditingResponses = true;
        },

        cancelEditResponses() {
            this.isEditingResponses = false;
            this.editableResponses = {};
        },

        async saveLeadResponses() {
            this.loadingSaveResponses = true;
            try {
                const response = await api.patch(`/capture-pages/${this.pageId}/leads/${this.selectedLead.id}/responses`, {
                    responses: this.editableResponses
                });
                
                const updatedLead = response.data.data;
                
                // 1. Atualiza as respostas do selectedLead preservando a reatividade
                if (updatedLead.responses) {
                    this.selectedLead.responses = { ...updatedLead.responses };
                } else {
                    // Fallback caso venha em outro formato, atualiza com o que foi editado
                    this.selectedLead.responses = { ...this.selectedLead.responses, ...this.editableResponses };
                }
                
                // 2. Atualiza a trilha de auditoria para exibir a alteração recém-criada
                if (updatedLead.activities) {
                    this.auditLogs = updatedLead.activities.filter(a => a.action !== 'note');
                }

                // 3. Atualiza o array principal da listagem/Kanban
                const index = this.leads.findIndex(l => l.id === this.selectedLead.id);
                if (index !== -1) {
                    this.leads[index].responses = { ...this.selectedLead.responses };
                }

                // Força o Vue a re-renderizar o lead selecionado perfeitamente
                this.selectedLead = { ...this.selectedLead };

                this.showAlert('Respostas atualizadas com sucesso!');
                this.isEditingResponses = false; // Fecha o modo de edição e volta pra visualização limpa
            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                } else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os dados inseridos.", "error");
                        return;
                    }
                    let mensagensErro = "Atenção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }
                    this.showAlert(mensagensErro, "error");
                } else {
                    console.error("Erro ao atualizar respostas:", e);
                    this.showAlert("Erro ao salvar alterações.", "error");
                }
            } finally {
                this.loadingSaveResponses = false;
            }
        },
        formatDateObjToString(dateObj) {
            const y = dateObj.getFullYear();
            const m = String(dateObj.getMonth() + 1).padStart(2, '0');
            const d = String(dateObj.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },

        isTodayCal(d, m, y) {
            const now = new Date();
            return d === now.getDate() && m === now.getMonth() && y === now.getFullYear();
        },

        getCalEventsForHour(dateObj, hour) {
            const dateStr = this.formatDateObjToString(dateObj);
            return this.filteredCalEvents.filter(e => {
                if (e.date !== dateStr) return false;
                if (!e.time) return false; // Se não tem hora, não exibe na visão diária nas horas específicas
                
                const eventHour = parseInt(e.time.split(':')[0], 10);
                return eventHour === hour;
            });
        },

        getCalEventsForDate(year, month, date) {
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
            const dayEvents = this.filteredCalEvents.filter(e => e.date === dateStr);
            // Ordena pela hora para ficar mais bonito
            return dayEvents.sort((a, b) => (a.time || '24:00').localeCompare(b.time || '24:00'));
        },

        getCalEventsCountForMonth(monthIndex) {
            const mString = String(monthIndex + 1).padStart(2, '0');
            return this.filteredCalEvents.filter(e => {
                 return e.date.split('-')[1] === mString;
            }).length;
        },

        goToTodayCal() {
            this.currentCalendarDate = new Date();
            this.scrollToCurrentCalTime();
        },

        navigateCal(step) {
            const newDate = new Date(this.currentCalendarDate);
            if (this.currentCalView === 'year') newDate.setFullYear(newDate.getFullYear() + step);
            else if (this.currentCalView === 'month') newDate.setMonth(newDate.getMonth() + step);
            else if (this.currentCalView === 'week') newDate.setDate(newDate.getDate() + (step * 7));
            else if (this.currentCalView === 'day') newDate.setDate(newDate.getDate() + step);
            this.currentCalendarDate = newDate;
        },

        goToMonthCal(index) { 
            this.currentCalendarDate.setMonth(index); 
            this.currentCalView = 'month'; 
        },
        
        goToSpecificDayCal(dateObj) { 
            this.currentCalendarDate = new Date(dateObj); 
            this.currentCalView = 'day'; 
        },

        scrollToCurrentCalTime() {
            this.$nextTick(() => {
                if (this.currentCalView !== 'day') return;
                
                if (!this.isTodayCal(this.currentCalendarDate.getDate(), this.currentCalendarDate.getMonth(), this.currentCalendarDate.getFullYear())) return;

                const currentHour = new Date().getHours();
                const targetHour = Math.max(0, currentHour - 1); 
                
                const container = this.$refs.timelineContainer;
                const targetElement = document.getElementById(`hour-row-${targetHour}`);

                if (container && targetElement) {
                    container.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        },

        // Função principal para abrir e mapear
        async openCalendarModal() {
            this.globalLoading.show('Montando agenda geral...');
            try {
                const response = await api.get(`/capture-pages/${this.pageId}/leads`, { params: { per_page: 'all' } });
                const payload = response.data;
                
                // Extração segura garantindo que allLeads seja estritamente um Array
                const allLeads = payload.data?.data || payload.data || [];

                if (!Array.isArray(allLeads)) {
                    console.warn("Retorno da API não é uma lista válida:", allLeads);
                    return;
                }
                
                this.allCalendarEvents = [];

                allLeads.forEach(lead => {
                    // 1. Mapear Atendimentos
                    if (lead.attendances && lead.attendances.length > 0) {
                        lead.attendances.forEach(att => {
                            if (att.next_contact_at) {
                                const datePart = att.next_contact_at.substring(0, 10);
                                const timePart = att.next_contact_at.substring(11, 16);
                                
                                this.allCalendarEvents.push({
                                    id: 'att_' + att.id,
                                    date: datePart,
                                    time: timePart !== '00:00' ? timePart : '',
                                    title: `${this.getLeadIdentifier(lead)} - ${att.reason?.title || 'Retorno'}`,
                                    type: 'attendance',
                                    lead: lead
                                });
                            }
                        });
                    }

                    // 2. Mapear Vínculos
                    if (lead.products_and_services && lead.products_and_services.length > 0) {
                        lead.products_and_services.forEach(item => {
                            if (item.return_date) {
                                const datePart = item.return_date.substring(0, 10);
                                const itemName = item.productable?.name || item.productable?.description || 'Item';
                                
                                this.allCalendarEvents.push({
                                    id: 'prod_' + item.id,
                                    date: datePart,
                                    time: '',
                                    title: `${itemName} (${this.getLeadIdentifier(lead)})`,
                                    type: 'product',
                                    lead: lead
                                });
                            }
                        });
                    }
                });

                this.currentCalendarDate = new Date();
                this.calendarFilter = 'all';

                if (!this.modalCalendarInstance) {
                    const el = document.getElementById('modalCalendar');
                    if (el) this.modalCalendarInstance = new window.bootstrap.Modal(el);
                }
                
                this.modalCalendarInstance.show();
                this.scrollToCurrentCalTime();

            } catch (error) {
                console.error("Erro calendário:", error);
                this.showAlert('Erro ao carregar dados da agenda.', 'error');
            } finally {
                this.globalLoading.hide();
            }
        },

        closeCalendarModal() {
            if (this.modalCalendarInstance) {
                this.modalCalendarInstance.hide();
            }
        },

        handleCalendarEventClick(evt) {
            if (evt.lead) {
                this.closeCalendarModal();
                
                // Abre o CRM
                this.openLeadCrmModal(evt.lead);
                
                // Vai direto para a aba correspondente
                setTimeout(() => {
                    this.activeTab = evt.type === 'attendance' ? 'details' : 'products';
                }, 300);
            }
        },

    }
}
</script>

<style scoped>
/* ================= Customização das Abas (Tabs) ================= */
.nav-tabs-custom {
    border-bottom: 1px solid #e2e8f0;
}

.nav-tabs-custom .nav-link {
    color: #64748b;
    border: none;
    border-bottom: 2px solid transparent;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
    transition: all 0.2s ease-in-out;
}

.nav-tabs-custom .nav-link:hover {
    color: #561569;
}

.nav-tabs-custom .nav-link.active {
    color: #561569;
    border-bottom: 2px solid #561569;
    background: transparent;
}

/* ================= CSS DA TRILHA DE AUDITORIA ================= */
.audit-scroll-container {
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
}

.timeline {
    position: relative;
    padding-left: 1rem;
}

.timeline::before {
    content: '';
    position: absolute;
    left: 1.25rem;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #e2e8f0;
}

.timeline-item {
    position: relative;
}

.timeline-marker {
    position: absolute;
    left: -0.15rem;
    top: 0.25rem;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #561569;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #e2e8f0;
    z-index: 1;
}

.last-child-no-border:last-child {
    border-bottom: none !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
}

/* ================= Estilos específicos do Kanban e D&D ================= */
.kanban-scroll-area {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.kanban-scroll-area::-webkit-scrollbar {
    display: none;
}

.col-kanban {
    flex: 1;
    min-width: 260px;
}

.kanban-card {
    transition: transform 0.2s, box-shadow 0.2s;
}

.kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
}

.cursor-grab {
    cursor: grab;
}

.cursor-grab:active {
    cursor: grabbing;
}

/* Customização Autocomplete */
.autocomplete-dropdown {
    border-color: #e2e8f0;
}

.autocomplete-item:hover {
    background-color: #f8fafc;
}

/* Cores de Fundo (Subtle) */
.bg-secondary-subtle {
    background-color: #f8f9fa !important;
}

.bg-info-subtle {
    background-color: #cff4fc !important;
}

.bg-primary-subtle {
    background-color: #cfe2ff !important;
}

.bg-warning-subtle {
    background-color: #fff3cd !important;
}

.bg-success-subtle {
    background-color: #d1e7dd !important;
}

.border-dashed {
    border: 2px dashed #cbd5e1 !important;
}

/* Mantendo os estilos PMG anteriores */
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-dark {
    background: #561569;
    color: #fff;
    border: none;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-responsive .dropdown-menu {
    z-index: 1060 !important;
    position: absolute !important;
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
}

.btn-pmg-primary:hover {
    background: #1a294d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(33, 51, 97, 0.2);
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-primary,
.btn-pmg-light,
.btn-pmg-danger {
    padding: 10px 24px !important;
    border-radius: 10px;
    font-weight: 500;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    height: 45px;
}

.btn-pmg-light:hover {
    background-color: #f8fafc;
    color: #1e293b;
    border-color: #cbd5e1;
}

.funnel-step {
    border-radius: 12px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}


.transition-all {
    transition: all 0.3s ease-in-out;
}

/* Estilização da barra de rolagem interna das colunas do Kanban */
.kanban-cards-container {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.kanban-cards-container::-webkit-scrollbar {
    width: 6px;
}

.kanban-cards-container::-webkit-scrollbar-track {
    background: transparent;
}

.kanban-cards-container::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 10px;
}

.kanban-cards-container::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}
::v-deep(.city-badge-label) {
    background-color: rgba(255, 255, 255, 0.9) !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
    padding: 4px 8px !important;
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    color: #1e293b !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}
.hide-map-labels ::v-deep(.leaflet-tooltip) {
    display: none !important;
}
.calendar-wrapper { height: 100%; }
.transition-hover-bg:hover { background: #fbfcfd !important; }
.timeline-scroll { overflow-y: auto; scroll-behavior: smooth; }
.hour-label { font-size: 0.75rem; }

.calendar-grid-header, .calendar-grid { display: grid; grid-template-columns: repeat(7, 1fr); }
.calendar-grid { background-color: #e2e8f0; gap: 1px; border-bottom: 1px solid #e2e8f0; }
.calendar-day { min-height: 120px; background-color: #fff; padding: 8px; display: flex; flex-direction: column; transition: background-color 0.2s; cursor: pointer; }
.calendar-day:hover:not(.empty-day) { background-color: #f8fafc; }

.event-list-scroll { flex-grow: 1; overflow-y: auto; max-height: 90px; scrollbar-width: none; }
.event-list-scroll::-webkit-scrollbar { display: none; }

.event-badge-mini {
    font-size: 0.7rem;
    padding: 3px 6px;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    border-radius: 4px;
    border-left: 3px solid;
}
.day-number { font-weight: 600; width: 26px; height: 26px; display: flex; align-items: center; justify-content: center; border-radius: 50%; }
.fs-8 { font-size: 0.75rem; }
</style>